import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Row, Col } from "react-flexbox-grid";
import { Link } from "react-router-dom";
import { Button, DialogContainer, SelectField, TextField } from "react-md";
import { Checkbox, CircularProgress, Menu, MenuItem } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/createAppointmentStyles.css";
import "./RescheduleDialog.css";
import FontIcon from "react-md/lib/FontIcons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import NavigoDashboardUtils from "../services/NavigoDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import debounce from "debounce";
import { TextField as TextField2 } from "@material-ui/core";
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {
  getStatusName,
  isEndStatus,
  isEndStatusCompleted,
  isEndStatusCancelled,
  LOCATION_MODE,
  APPOINTMENT_PAYMENT_STATUS,
  SERVICE_TYPE,
  SERVICE_SUB_TYPE,
  MODES,
  MODES_WITH_AUTO_SP,
  NAVIGO_STATUS,
  REFUND_STATUS,
  CANCEL_APP_OPTION,
  navigoLabtestStatus,
  hraStatuses,
  LAB_WORKFLOW_STATUSES,
  isConsultation,
  opensCallNote,
} from "../helper/appointmentConstants";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import PaymentAndRefund from "./refund/PaymentAndRefund";
import EventHistoryPaymentDetails from "./refund/EventHistoryPaymentDetails";
import {
  getPaymentStatusDisplay,
  getRefundStatusDisplay,
} from "../helper/paymentViewModel";
import { CancelAppointmentDialog } from "./refund/CancelAppointmentDialog";
import { CancelAppointmentFlow } from "./refund/CancelAppointmentFlow";
/* phr's call note (v2 endpoints, its templates and its save -> send-to-chat ->
   lock flow) — the same modal the appointments-v2 board opens from "Add
   callnote" and from a status change there, so the note is the same wherever a
   status is set (Nittin, 2026-09-24). */
import CallNoteModal from "modules/patient/components/CallNoteModal";
import { useRefundDialog } from "./refund/useRefundDialog";
import { RefundDialog } from "./refund/RefundDialog";
import {
  LocationSearchDialog,
  useLocationDialog,
} from "../helper/useLocationDialog";
import TopNote from "../../../../../components/common/TopNote";
import redirIcon from "../../../../../assets/icons/redir_orange.svg";
import TextFieldBlack from "../../../../../modules/commonComponents/TextFieldBlack";
import CallPatientOptions from "./CallPatientOptions";
import RefreshButton from "../helper/RefreshButton";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { PiSunHorizon, PiSunLight } from "react-icons/pi";
import { WiSunset } from "react-icons/wi";
import { FiMoon } from "react-icons/fi";
import {
  RiCalendar2Line,
  RiCloseLine,
  RiDirectionLine,
  RiEyeLine,
  RiMore2Fill,
  RiPlayCircleLine,
} from "react-icons/ri";
import { CartDashboardUtils } from "../../cart-module/services/CartDashboardUtils";
import DocCartView from "../../cart-module/components/PrescribedDiagnosticsComponents/DocCartView";
import CartRescheduleDialog from "../../cart-module/components/CartRescheduleDialog";
import { hasFrozenPrices } from "../../cart-module/constants/cart-constants";
import NavigoAPIServices from "../../navigo-dashboard/services/navigoAPIServices";
import successGif from "../../../../../assets/images/done-animation.gif";

// Reschedule slots are grouped into time-of-day accordions by their start time
// (minutes from midnight). Only buckets that actually have slots are rendered.
const SLOT_BUCKETS = ["Morning", "Afternoon", "Evening", "Night"];
const SLOT_BUCKET_ICONS = {
  Morning: PiSunHorizon,
  Afternoon: PiSunLight,
  Evening: WiSunset,
  Night: FiMoon,
};
const slotBucketOf = (mins) => {
  if (mins == null) return "Morning";
  if (mins >= 0 && mins < 720) return "Morning"; // 12 AM – 11:59 AM
  if (mins >= 720 && mins < 960) return "Afternoon"; // 12 PM – 3:59 PM
  if (mins >= 960 && mins < 1200) return "Evening"; // 4 PM – 7:59 PM
  return "Night"; // ≥ 8 PM
};
// Days fetched per request from /available-slots/range.
const SLOT_WINDOW_DAYS = 7;
// The weekday labels the slots API uses for dayStr, indexed by moment().day()
// (0 = Sunday), so a tile built for a date the response doesn't cover reads the
// same as the ones it does.
const SLOT_DAY_ABBREVIATIONS = ["Su", "M", "Tu", "W", "Th", "F", "Sa"];
const EMPTY_SLOT_WINDOW = {
  loading: false,
  error: null,
  days: [],
  windowStart: null,
  minBookingDate: null,
  maxBookingDate: null,
};

export const DocumentUpload = (props) => {
  const [loading, setLoading] = useState(false);
  const [appointment, setAppointment] = useState(null);
  const [reasonList, setReasonList] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [appDocMap, setAppDocMap] = useState([]);
  const [appointmentAudits, setAppointmentAudits] = useState([]);
  // Number of times this appointment has been rescheduled, from the audit API.
  // Surfaced in the summary strip as a link into the Appointment history table.
  const [rescheduleCount, setRescheduleCount] = useState(0);
  const appointmentHistoryRef = useRef(null);
  // Blob URLs for call recordings, keyed by recording id, plus the id currently
  // being fetched.
  const [recordingUrls, setRecordingUrls] = useState({});
  const [loadingRecordingId, setLoadingRecordingId] = useState(0);
  const [token, setToken] = useState("");
  const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
  const [openCartReschedule, setOpenCartReschedule] = useState(false);
  const [serviceProviderListToShow, setServiceProviderListToShow] = useState(
    [],
  );
  const [serviceProviderSelected, setServiceProviderSelected] = useState(null);
  const [priorityVendorMappedSpIds, setPriorityVendorMappedSpIds] = useState(
    [],
  );
  const [dateSelected, setDateSelected] = useState(null);
  // The 7-day window last returned by /available-slots/range, with the booking
  // bounds the backend computed for it:
  //   { loading, error, days: response[], minBookingDate, maxBookingDate }
  const [slotWindow, setSlotWindow] = useState(EMPTY_SLOT_WINDOW);
  // Identifies the provider/language/start-date combination a window was fetched
  // for, so a response for a superseded combination can be dropped.
  const slotRequestKeyRef = useRef("");
  const [slotSelected, setSlotSelected] = useState(null);
  const [selectServiceProviderCheckbox, setSelectServiceProviderCheckbox] =
    useState(false);
  const [serviceProviderAutoSelected, setServiceProviderAutoSelected] =
    useState(null);
  const [homeSampleDateMin, setHomeSampleDateMin] = useState(null);
  const [homeSampleDateMax, setHomeSampleDateMax] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [languageSelected, setLanguageSelected] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [stateSelected, setStateSelected] = useState(null);
  const [cityList, setCityList] = useState([]);
  const [citySelected, setCitySelected] = useState(null);
  const [localityList, setLocalityList] = useState([]);
  const [localitySelected, setLocalitySelected] = useState(null);
  const [serviceProviderOfApp, setServiceProviderOfApp] = useState(null);
  const [updatePatientInfoDialog, setUpdatePatientInfoDialog] = useState(false);
  const [updateExtOrderIdDialog, setUpdateExtOrderIdDialog] = useState(false);
  const [newExtOrderId, setNewExtOrderId] = useState("");
  const [loadingProfileUpdate, setLoadingProfileUpdate] = useState(false);
  const [patientInfo, setPatientInfo] = useState(null);
  const [patientInfoOnPageLoad, setPatientInfoOnPageLoad] = useState(null);
  const [primaryPatientInfoOnPageLoad, setPrimaryPatientInfoOnPageLoad] =
    useState(null);
  const [newDob, setNewDob] = useState(null);
  const [newEmail, setNewEmail] = useState("");
  const [userAddress, setUserAddress] = useState(null);
  // Reschedule dialog: reason chips, the "Other reason" comment, the calendar
  // date that re-centres the 7-day strip, and the success confirmation.
  const [rescheduleReasons, setRescheduleReasons] = useState([]);
  const [reasonSelected, setReasonSelected] = useState(null);
  const [otherReasonComment, setOtherReasonComment] = useState("");
  // First date of the strip ("YYYY-MM-DD"), set from the calendar. null lets the
  // backend open the window on the earliest bookable date.
  const [slotRangeStartDate, setSlotRangeStartDate] = useState(null);
  // Which time-of-day accordions the user has opened on the selected date. It is
  // cleared whenever a date is picked, so each date starts with only its first
  // accordion open.
  const [slotBucketToggle, setSlotBucketToggle] = useState({
    dateKey: null,
    expanded: [],
  });
  const [customDatePickerOpen, setCustomDatePickerOpen] = useState(false);
  const [rescheduledSummary, setRescheduledSummary] = useState(null);
  const [availCareDateMin, setAvailCareDateMin] = useState(null);
  const [availCareDateMax, setAvailCareDateMax] = useState(null);
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const patientService = new PatientsService();
  const uploadFileRef = useRef(null);
  const [locationModeSelected, setLocationModeSelected] = useState(null);
  const [geoLocData, setGeoLocData] = useState(null);
  const [rangeOptionSelected, setRangeOptionSelected] = useState(null);
  const [addressList, setAddressList] = useState([]);
  const [addressSelected, setAddressSelected] = useState(null);
  const [loaderToCheckPaymentStatus, setLoaderToCheckPaymentStatus] =
    useState(false);
  const [isUploadingDoc, setIsUploadingDoc] = useState(false);
  // Appointment status change (mirrors NavigoDashboard's status dropdown flow)
  const [statusMenuAnchor, setStatusMenuAnchor] = useState(null);
  // "User details" overflow menu, and the Profile details dialog it opens.
  // "Age and Gender" stays masked in the card; the real values are only shown
  // inside that dialog.
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [updatingStatusId, setUpdatingStatusId] = useState(0);
  const [appToBeCancelled, setAppToBeCancelled] = useState(null);
  // The restyled cancel flow, used only for the "Cancelled" status.
  const [appToBeCancelledNewFlow, setAppToBeCancelledNewFlow] = useState(null);
  /** The appointment whose call note is open after a status change, or null. */
  const [callNoteFor, setCallNoteFor] = useState(null);
  const [statusToBeApplied, setStatusToBeApplied] = useState(null);
  const [showCancelAppDialog, setShowCancelAppDialog] = useState(false);
  const [cancelAppOption, setCancelAppOption] = useState(
    CANCEL_APP_OPTION.NONE,
  );
  const {
    dialogState: refundDialogState,
    setDialogState: setRefundDialogState,
    openRefundDialog,
    handleClose: handleRefundDialogClose,
  } = useRefundDialog();
  const [cartDetails, setCartDetails] = useState(null);
  const [cartDocumentsList, setCartDocumentsList] = useState([]);
  const [cartSelectedDocument, setCartSelectedDocument] = useState(null);
  // Cart's serviceIds resolved into real test details (name + subtest count) and
  // its provider resolved with address/distance — reuses the same cart APIs the
  // PrescribedDiagnosticsScreen verify/edit flow uses, so the read-only cart
  // view shows real data instead of "Service #id" placeholders.
  const [cartTestItems, setCartTestItems] = useState([]);
  const [cartSelectedProvider, setCartSelectedProvider] = useState(null);
  // The cart's addressId resolved into the patient's saved address, used to show
  // the home-sample booking address (with its Google Maps link) in the read-only
  // cart view. Centre-visit carts show the provider's address instead.
  const [cartAddressSelected, setCartAddressSelected] = useState(null);
  // Whether the cart's plan has a wallet (walletDetails.isWalletIncluded). Gates the
  // "Wallet not eligible" tags in the read-only cart view: on a plan without a wallet
  // the wallet never enters the sublimit/payment calls, so every test would read as
  // not-eligible and the tag is noise. False until the plan's wallet status is known.
  const [cartPlanWalletIncluded, setCartPlanWalletIncluded] = useState(false);
  // The cart's frozen price break-up. `cartPriceRows` holds the priced services that are not cart
  // items (the home-sample collection charge, priced as its own row); `cartPriceTotal` is the total
  // the cart was booked at. Both stay empty for a cart with no frozen prices.
  const [cartPriceRows, setCartPriceRows] = useState([]);
  const [cartPriceTotal, setCartPriceTotal] = useState(null);
  const cartDashboardUtils = new CartDashboardUtils();
  const navigoAPIServices = new NavigoAPIServices();

  const APOLLO_VENDOR_CODE = "ApolloClinic";
  // Extra reason chip (not returned by the API) that reveals a free-text comment.
  const OTHER_REASON = "Other reason";
  function isAutoSPAllowed(mode) {
    return MODES_WITH_AUTO_SP.includes(mode);
  }

  // cartId is only set on appointments created from a cart, and it is omitempty — so
  // the same > 0 guard used for the cart details section below.
  const isCartAppointment = (app) => (app?.cartId ?? 0) > 0;

  let SELECT_LOCATION_MODE_OPTIONS = [
    {
      label: "Google maps",
      value: LOCATION_MODE.GOOGLE_MAPS,
    },
    {
      label: "Manual",
      value: LOCATION_MODE.MANUAL,
    },
    {
      label: "Saved Addresses",
      value: LOCATION_MODE.SAVED_ADDRESSES,
    },
  ];
  const AUTO_RADIUS_SEQUENCE = [6, 10, 15];

  let LOCATION_RANGE_KMS_OPTIONS = [
    {
      label: "6 Km",
      value: 6,
    },
    {
      label: "10 Km",
      value: 10,
    },
    {
      label: "15 Km",
      value: 15,
    },
    {
      label: "30 Km",
      value: 30,
    },
    {
      label: "50 Km",
      value: 50,
    },
    {
      label: "75 Km",
      value: 75,
    },
    {
      label: "100 Km",
      value: 100,
    },
  ];

  useEffect(() => {
    fetchAppointment();
    fetchReasonsForConsultation();
    generateDocumentToken();
    getAppointmentDocMapping(props.data.appId);
    getAppointmentAudit(props.data.appId);
    fetchPriorityVendors();
  }, []);

  useEffect(() => {
    if (appointment != null && reasonList != null) {
      if (
        isMounted === false &&
        props?.data?.from === "SLOT_RESTRICTION_DASHBOARD"
      ) {
        startRescheduleFlow();
      }
      setIsMounted(true);
    }
  }, [appointment, reasonList]);

  useEffect(() => {
    if (openRescheduleDialog) {
      // getProviderOfPlanService();
      getServiceProvider({
        type: 1,
        lang: [],
        state: null,
        city: null,
        locality: null,
      });
      getRescheduleReasons();
    }
  }, [openRescheduleDialog]);
  useEffect(() => {
    resetValues(2);
    if (openRescheduleDialog) {
      getServiceProvider({
        type: 2,
        lang: languageSelected,
        state: null,
        city: null,
        locality: null,
      });
    }
  }, [languageSelected]);

  useEffect(() => {
    if (dateSelected != null) {
      setSlotSelected(null);
      // Every date picked starts with every accordion open.
      setSlotBucketToggle({ dateKey: null, expanded: [] });
    }
  }, [dateSelected]);
  useEffect(() => {
    if (stateSelected != null) {
      getSPLocationCity();
    }
  }, [stateSelected]);
  useEffect(() => {
    if (citySelected != null) {
      getSPLocationLocality();
    }
  }, [citySelected]);

  // Frontend estimate of the bookable range. Only used as the calendar's bounds
  // until the backend's own minBookingDate / maxBookingDate arrive with a window.
  const rescheduleMinDate = moment(
    getMinDate(
      appointment,
      homeSampleDateMin,
      selectServiceProviderCheckbox,
      serviceProviderSelected,
    ),
  ).startOf("day");
  const rescheduleMaxDate = getMaxDate(
    appointment,
    homeSampleDateMax,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  );
  // The calendar has to stay inside the backend's bookable range: a
  // slotRangeStartDate outside it is rejected with a 400, not clamped.
  const calendarMinDate = slotWindow.minBookingDate
    ? moment(slotWindow.minBookingDate, "YYYY-MM-DD")
    : rescheduleMinDate;
  const calendarMaxDate = slotWindow.maxBookingDate
    ? moment(slotWindow.maxBookingDate, "YYYY-MM-DD")
    : rescheduleMaxDate;
  const isProviderChosen =
    selectServiceProviderCheckbox || serviceProviderSelected != null;
  const selectedDateKey =
    dateSelected == null ? null : moment(dateSelected).format("YYYY-MM-DD");
  const selectedDay =
    selectedDateKey == null
      ? null
      : (slotWindow.days.find((day) => day?.dayDate === selectedDateKey) ??
        null);
  // A day is only pickable when the backend reports it available AND it has
  // slots. "no_slots" and "unavailable" (a day that failed to resolve) are grey.
  const isDayAvailable = (day) =>
    day?.status === "available" &&
    Array.isArray(day?.slots) &&
    day.slots.length > 0;
  // The strip always shows SLOT_WINDOW_DAYS consecutive dates: from the calendar
  // pick, else from where the backend opened the window, else — before any
  // response — from the frontend's earliest-bookable estimate. A date the
  // response doesn't cover (past maxBookingDate, still loading, or a failed
  // request) still gets a tile; without slots it simply renders grey.
  const slotStripStart = slotRangeStartDate
    ? moment(slotRangeStartDate, "YYYY-MM-DD")
    : slotWindow.windowStart
      ? moment(slotWindow.windowStart, "YYYY-MM-DD")
      : rescheduleMinDate;
  const slotStripDays = Array.from({ length: SLOT_WINDOW_DAYS }, (_, index) => {
    const date = moment(slotStripStart).add(index, "days");
    const dateKey = date.format("YYYY-MM-DD");
    return (
      slotWindow.days.find((day) => day?.dayDate === dateKey) ?? {
        dayDate: dateKey,
        dayStr: SLOT_DAY_ABBREVIATIONS[date.day()],
        dayNum: date.date(),
        slots: [],
      }
    );
  });
  // The selected day's slots grouped by time of day, in bucket order, with
  // empty buckets dropped.
  const selectedDaySlotBuckets = SLOT_BUCKETS.map((bucket) => ({
    bucket,
    slots: (selectedDay?.slots ?? []).filter(
      (slot) => slotBucketOf(slot?.value) === bucket,
    ),
  })).filter((group) => group.slots.length > 0);
  // Toggles only apply to the date they were made on. Keying on the date (rather
  // than relying on the reset in the dateSelected effect alone) means the render
  // that switches dates already shows the new date's default, with no frame of
  // the previous date's open/closed state.
  const expandedSlotBuckets =
    slotBucketToggle.dateKey === selectedDateKey
      ? slotBucketToggle.expanded
      : selectedDaySlotBuckets.slice(0, 1).map((group) => group.bucket);
  const toggleSlotBucket = (bucket) => {
    setSlotBucketToggle({
      dateKey: selectedDateKey,
      expanded: expandedSlotBuckets.includes(bucket)
        ? expandedSlotBuckets.filter((b) => b !== bucket)
        : [...expandedSlotBuckets, bucket],
    });
  };
  // Identifies what a window was fetched for. Any change refetches, and a
  // response for a superseded key is dropped.
  const slotRequestKey = `${
    selectServiceProviderCheckbox
      ? "auto"
      : (serviceProviderSelected?.id ?? "none")
  }|${(languageSelected ?? []).join(",")}|${slotRangeStartDate ?? ""}`;

  // Fetch the 7-day window once the dialog is open with a provider chosen, and
  // again whenever the provider, languages or start date change. Without a
  // provider nothing is requested: serviceProviderID 0 would silently switch the
  // backend into auto-selection.
  useEffect(() => {
    slotRequestKeyRef.current = slotRequestKey;
    if (!openRescheduleDialog || !isProviderChosen) {
      setSlotWindow(EMPTY_SLOT_WINDOW);
      return;
    }
    fetchSlotWindow(slotRangeStartDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openRescheduleDialog, isProviderChosen, slotRequestKey]);

  // With auto-selection on, the provider is resolved per day by the backend, so
  // it follows whichever day is selected.
  useEffect(() => {
    if (!selectServiceProviderCheckbox) {
      return;
    }
    setServiceProviderAutoSelected(selectedDay?.serviceProviderId ?? null);
  }, [selectServiceProviderCheckbox, selectedDay]);

  const getBookingConfigByVendor = (pid, serviceId, planId, vendorId) => {
    const onResponse = (res) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    navigoDashboardUtils.getBookingConfigByVendor(
      {
        patientID: pid,
        serviceID: serviceId,
        planID: planId,
        vendorId: vendorId,
      },
      onResponse,
      onError,
    );
  };

  const getAddressById = (addressId) => {
    const onResponse = (res) => {
      if (res) {
        setUserAddress(res);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    if (addressId > 0) {
      navigoDashboardUtils.getAddressById(addressId, onResponse, onError);
    }
  };

  // Reasons shown as chips in the reschedule dialog. "Other reason" is appended
  // by the UI and is not part of the API response.
  const getRescheduleReasons = () => {
    const onResponse = (res) => {
      setRescheduleReasons(Array.isArray(res) ? res : []);
    };
    const onError = (err) => {
      setRescheduleReasons([]);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getRescheduleReasons(onResponse, onError);
  };

  // Loads one SLOT_WINDOW_DAYS-day window from /available-slots/range. A null
  // startDate lets the backend open the window on the earliest bookable date;
  // otherwise it opens on that date, which must lie inside the bookable range.
  const fetchSlotWindow = (startDate) => {
    const requestKey = slotRequestKeyRef.current;
    // A response is only applied while it still matches the selection that asked
    // for it.
    const isCurrent = () => slotRequestKeyRef.current === requestKey;
    // Vendor identifiers come from the picked provider when it carries them,
    // and otherwise from the appointment being rescheduled — modes such as home
    // sample have no provider dropdown, so the appointment is the only source.
    const vendorId = serviceProviderSelected?.vendorId
      ? serviceProviderSelected.vendorId
      : (appointment?.vendorId ?? "");
    const vendorCode = serviceProviderSelected?.vendorCode
      ? serviceProviderSelected.vendorCode
      : (appointment?.vendorCode ?? "");
    // 0 means "no vendor doctor", so it falls back like an empty value does.
    const vendorDoctorId = serviceProviderSelected?.vendorDoctorId
      ? serviceProviderSelected.vendorDoctorId
      : (appointment?.vendorDoctorId ?? 0);
    const slotMemberPatientId =
      appointment?.bookedFor > 0
        ? appointment.bookedFor
        : appointment?.patientID;
    const body = {
      planId: appointment?.planID,
      serviceId: appointment?.serviceID,
      // 0 asks the backend to auto-select a provider per day. It is only valid
      // alongside bookingMode, which is always sent.
      serviceProviderID: selectServiceProviderCheckbox
        ? 0
        : (serviceProviderSelected?.id ?? 0),
      slotRangeStartDate: startDate ?? "",
      numDays: SLOT_WINDOW_DAYS,
      bookingMode: appointment?.mode,
      addressId: appointment?.addressId,
      vendor: vendorId,
      vendorCode: vendorCode,
      vendorDoctorId: vendorDoctorId,
      languageMatch: languageSelected ?? [],
      providerAddressId: appointment?.providerAddressId ?? "",
      // patientId is the plan holder: the backend reads plan details with it.
      // bookedFor and memberPatientId are the person the appointment is for —
      // the family member on a family booking (bookedFor > 0), otherwise the
      // plan holder themself. Both must carry the member: bookedFor drives the
      // provider lookups and memberPatientId the per-day slot lookups, so
      // setting only one would check providers and slots for different people.
      patientId: appointment?.patientID,
      bookedFor: slotMemberPatientId,
      memberPatientId: slotMemberPatientId,
      isReschedule: true,
      ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
        selectL2Availability: true,
      }),
    };
    // Keep the booking bounds so the calendar stays usable while loading.
    setSlotWindow((prev) => ({
      ...prev,
      loading: true,
      error: null,
      days: [],
    }));
    const onResponse = (res) => {
      if (!isCurrent()) return;
      setSlotWindow({
        loading: false,
        error: null,
        days: Array.isArray(res?.response) ? res.response : [],
        windowStart: res?.windowStart || null,
        minBookingDate: res?.minBookingDate || null,
        maxBookingDate: res?.maxBookingDate || null,
      });
      // Days that failed to resolve come back as "unavailable" and render grey;
      // say so once rather than leaving them looking fully booked.
      if (res?.partialFailure === true) {
        EventService.emit("showError", {
          message: `Some dates could not be loaded and are shown as unavailable`,
        });
      }
    };
    const onError = (err) => {
      if (!isCurrent()) return;
      const message = err?.message ?? "Something went wrong";
      EventService.emit("showError", {
        message: `Error: ${message}`,
      });
      setSlotWindow((prev) => ({
        ...prev,
        loading: false,
        error: message,
        days: [],
      }));
    };
    navigoDashboardUtils.getAvailableSlotsByRange(body, onResponse, onError);
  };

  function isCentreVisitNotApollo(appointment) {
    return (
      appointment?.mode === MODES.CENTRE_VISIT &&
      appointment?.serviceProviderGroupVendorName !== APOLLO_VENDOR_CODE
    );
  }

  const findRangeOptionByRadius = (radius) =>
    LOCATION_RANGE_KMS_OPTIONS.find((opt) => opt.value === radius) || null;

  const getServiceProvider = ({
    type = null, // type 1 = initial fetch, type 2 = after language selection, type 3 = after location selection
    lang = [],
    state = null,
    city = null,
    locality = null,
    range = null,
  }) => {
    setLoading(true);

    const executeCall = (currentRange, autoIndex = 0) => {
      // Base request body
      let body = {
        pageNum: 0,
        pageSize: 0,
        planId: appointment?.planID,
        serviceId: appointment?.serviceID,
        serviceMode: appointment?.mode,
        patientId: appointment?.patientID,
        languageMatch: lang ?? [],
        vendorCode: appointment?.vendorCode,
        vendorDoctorId: appointment?.vendorDoctorId,
        vendorId: appointment?.vendorId,
        providerAddressId: appointment?.providerAddressId ?? "",
        geolocationFilter:
          range?.latLng && currentRange
            ? {
                longitude: range.latLng.lng,
                latitude: range.latLng.lat,
                radius: currentRange.radius * 1000, // km to meters
              }
            : null,
        ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
          selectL2Availability: true,
        }),
      };

      // type === 3 (location based filter)
      if (type === 3 && state && city) {
        body = {
          ...body,
          locationFilter: [
            {
              stateMatch: state,
              cityMatch: city,
              ...(locality != null && { landmarkMatch: locality }),
            },
          ],
        };
      }

      // Exclude Apollo if needed
      if (appointment?.serviceProviderGroupVendorName !== APOLLO_VENDOR_CODE) {
        body = {
          ...body,
          excludedVendors: [APOLLO_VENDOR_CODE],
        };
      }

      const onResponse = (res) => {
        const providers = res?.providers ?? [];

        // If found → success
        if (providers.length > 0) {
          setServiceProviderListToShow(providers);

          // type === 1 special selection logic
          if (type === 1) {
            const pro = providers.find(
              (e) => e.id === appointment?.serviceProviderID,
            );
            setServiceProviderSelected(pro ?? null);

            if (!pro) {
              EventService.emit("showError", {
                message: `Unable to set the same service provider`,
              });
            }
          }

          setLoading(false);
          return;
        }

        // AUTO RADIUS RETRY LOGIC
        if (
          currentRange?.autocheck === true &&
          autoIndex < AUTO_RADIUS_SEQUENCE.length - 1
        ) {
          const nextRadius = AUTO_RADIUS_SEQUENCE[autoIndex + 1];

          const nextRangeOpt = findRangeOptionByRadius(nextRadius);
          if (nextRangeOpt) {
            setRangeOptionSelected(nextRangeOpt);
          }

          executeCall(
            { radius: nextRadius, autocheck: true, latLng: range.latLng },
            autoIndex + 1,
          );
          return;
        }

        // Not found even after retries
        setServiceProviderListToShow([]);
        setLoading(false);

        EventService.emit("showError", {
          message: `No service provider found`,
        });
      };

      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };

      navigoDashboardUtils.getServiceProvider(body, onResponse, onError);
    };

    // Start initial call
    executeCall(range, AUTO_RADIUS_SEQUENCE.indexOf(range?.radius));
  };
  const fetchAppointment = () => {
    const onResponse = (res) => {
      if (
        res != null &&
        res.appointments != null &&
        res.appointments.length != 0
      ) {
        // Cart-created appointments carry the cart id (CartId, omitempty) on the
        // appointment; non-cart appointments have no cartId, so the cart section
        // is skipped. Guard on > 0 so a missing/zero cartId doesn't fetch.
        const appointmentObj = res.appointments[0];
        setAppointment(appointmentObj);
        if (appointmentObj?.cartId > 0) {
          fetchCartDetails(appointmentObj.cartId);
        }
        getServiceProviderOfApp(res.appointments[0]);
        checkPatientInfoOnPageLoad(
          res.appointments[0]?.bookedFor == 0
            ? res.appointments[0]?.patientID
            : res.appointments[0]?.bookedFor,
        );
        if (res.appointments[0]?.bookedFor != 0) {
          checkPrimaryPatientInfoOnPageLoad(res.appointments[0]?.patientID);
        }
        if (
          res.appointments[0]?.serviceTypeID === SERVICE_TYPE.CONSULTATION &&
          res.appointments[0]?.serviceSubtypeID === SERVICE_SUB_TYPE.AVAIL_CARE
        ) {
          getAvailCareDates(
            res.appointments[0]?.patientID,
            res.appointments[0]?.planID,
          );
        } else {
          setAvailCareDateMax(null);
          setAvailCareDateMin(null);
        }
        if (res.appointments[0]?.mode === MODES.HOME_SAMPLE) {
          getAddressById(res.appointments[0]?.addressId ?? 0);
          if (res.appointments[0]?.serviceTypeID === SERVICE_TYPE.VACCINE) {
            const appointObj = res.appointments[0];
            getBookingConfigByVendor(
              appointObj?.patientID,
              appointObj?.serviceID,
              appointObj?.planID,
              appointObj?.vendorId,
            );
          } else {
            getHomeSampleDates(res.appointments[0]);
          }
        } else {
          setHomeSampleDateMin(null);
          setHomeSampleDateMax(null);
        }
        if (res.appointments[0].serviceTypeID === SERVICE_TYPE.CONSULTATION) {
          getLanguages(res.appointments[0]);
        }
        if (
          (res.appointments[0].serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP ||
            res.appointments[0].serviceTypeID === SERVICE_TYPE.VACCINE) &&
          (isCentreVisitNotApollo(res.appointments[0]) ||
            res.appointments[0].mode === MODES.CAMP_SITE_VISIT)
        ) {
          getSPLocationState(res.appointments[0]);
        }
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.fetchAppointments(
      {
        pageNum: 1,
        pageSize: 1,
        appointmentId: props.data.appId,
        includeAppointmentPayments: true,
        includeEvents: true,
      },
      onResponse,
      onError,
      true, // includeServiceDetails — only requested on this screen
    );
  };

  const fetchCartDetails = (cartId) => {
    cartDashboardUtils.fetchCartById(
      cartId,
      (res) => {
        if (res) {
          setCartDetails(res);
          if (
            res.prescriptionDocumentIds &&
            res.prescriptionDocumentIds.length > 0
          ) {
            fetchCartDocuments(res.prescriptionDocumentIds);
          }
          resolveCartTestsAndProvider(res);
          resolveCartAddress(res);
          resolveCartPlanWalletIncluded(res);
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error fetching cart: ${err?.message}`,
        });
      },
      // The appointment's cart is booked, so its per-service prices are frozen on the head
      // cart_payment_request. `includePrices` brings them back as `serviceBreakup`.
      { includePrices: true },
    );
  };

  // The cart-by-id API does not return the plan's wallet configuration, so derive it
  // from the cart's planId the same way the verify/edit screen does.
  const resolveCartPlanWalletIncluded = (cart) => {
    if (!cart?.planId) {
      setCartPlanWalletIncluded(false);
      return;
    }
    cartDashboardUtils.fetchPlanWalletRulesByPlanId(
      cart.planId,
      (rules) => setCartPlanWalletIncluded(rules?.isWalletIncluded === true),
      () => setCartPlanWalletIncluded(false),
    );
  };

  // Resolve the cart's serviceIds into real test details and its provider into
  // the full provider object (address / distance / map link), using the same
  // cart-service APIs as the verify/edit screen.
  //
  // Prices come from the cart's frozen break-up, never from the provider response: this cart is
  // already booked, so the coverage API's live prices can have drifted away from what the patient
  // actually paid. The provider's own totalPrice is zeroed for the same reason — the booked total
  // is passed to DocCartView as priceTotal instead.
  const resolveCartTestsAndProvider = (cart) => {
    const searchParams = {
      planId: cart.planId,
      patientId: cart.patientId,
      groupServiceId: cart.groupServiceId,
    };
    if (Array.isArray(cart.serviceIds) && cart.serviceIds.length > 0) {
      cartDashboardUtils.fetchChildServicesByIds(
        cart.serviceIds,
        searchParams,
        (tests) => {
          if (!hasFrozenPrices(cart.status)) {
            setCartTestItems(tests || []);
            return;
          }
          const { items, extraRows, total } =
            cartDashboardUtils.applyServiceBreakup(
              tests || [],
              cart.serviceBreakup,
            );
          setCartTestItems(items);
          setCartPriceRows(extraRows);
          setCartPriceTotal(total);
        },
        (err) =>
          console.error("Error resolving cart tests:", err?.message || err),
      );
      cartDashboardUtils.fetchProviders(
        {
          ...searchParams,
          serviceIds: cart.serviceIds,
          addressId: cart.addressId,
          // Booking-for patient, so this re-fetch is scoped the same way the original
          // booking was. Only the matching provider is read out of the response here, but
          // sending it keeps that lookup against the same coverage the cart was booked from.
          bookedFor: cart.bookedFor,
        },
        (resp) => {
          const provider = (resp?.providers || []).find(
            (p) => p.id === cart.serviceProviderId,
          );
          if (provider) {
            setCartSelectedProvider({ ...provider, totalPrice: 0 });
          }
        },
        (err) =>
          console.error("Error resolving cart provider:", err?.message || err),
      );
    }
  };

  // Resolve the cart's addressId into the patient's saved address (home-sample
  // carts only) so the read-only cart view can show the booking address with its
  // Google Maps link — mirrors the verify/edit screen, which fetches the
  // patient's addresses and matches the cart's addressId. Centre-visit carts
  // surface the provider's centre address via selectedProvider instead.
  const resolveCartAddress = (cart) => {
    if (
      cart?.mode !== MODES.HOME_SAMPLE ||
      !(cart?.addressId > 0) ||
      !(cart?.patientId > 0)
    ) {
      return;
    }
    navigoDashboardUtils.getPatientAddress(
      cart?.bookedFor > 0 ? cart?.bookedFor : cart?.patientId,
      (res) => {
        const addresses = Array.isArray(res) ? res : [];
        const match = addresses.find((a) => a.id === cart.addressId);
        if (match) {
          setCartAddressSelected(match);
        }
      },
      (err) =>
        console.error("Error resolving cart address:", err?.message || err),
    );
  };

  const fetchCartDocuments = async (documentIds) => {
    if (!Array.isArray(documentIds) || documentIds.length === 0) return;
    try {
      const docs = await Promise.all(
        documentIds.map((docId) => {
          return new Promise((resolve, reject) => {
            navigoAPIServices.getDocuments(
              docId,
              (res) => resolve(res),
              (err) => {
                console.error(`Error fetching document ID ${docId}:`, err);
                reject(err);
              },
            );
          });
        }),
      );
      setCartDocumentsList(docs);
      if (docs.length > 0) {
        setCartSelectedDocument(docs[0]);
      }
    } catch (error) {
      console.error("Error fetching cart documents:", error);
    }
  };

  const fetchAppointmentDetailsOnly = () => {
    setLoaderToCheckPaymentStatus(true);
    const onResponse = (res) => {
      if (
        res != null &&
        res.appointments != null &&
        res.appointments.length != 0
      ) {
        setAppointment(res.appointments[0]);
      }
      setLoaderToCheckPaymentStatus(false);
      props.resetDashboardReload();
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoaderToCheckPaymentStatus(false);
    };
    navigoDashboardUtils.fetchAppointments(
      {
        pageNum: 1,
        pageSize: 1,
        appointmentId: props.data.appId,
        includeAppointmentPayments: true,
        includeEvents: true,
      },
      onResponse,
      onError,
      true, // includeServiceDetails — only requested on this screen
    );
  };
  // ---- Appointment status change (ported from NavigoDashboard) ----
  const onRefreshStatus = () => {
    fetchAppointment();
    // A status change adds an audit entry, so keep the history table in sync.
    getAppointmentAudit(props.data.appId);
    if (props.resetDashboardReload) {
      props.resetDashboardReload();
    }
  };

  const handleAppointmentStatusChange = (value, ele) => {
    setUpdatingStatusId(ele.id);
    let body = {
      appointmentID: ele.id,
      reportUrl: "",
      status: value,
    };
    const onResponse = (res) => {
      setUpdatingStatusId(0);
      onRefreshStatus();
      /* A status change that lands is the one moment a call outcome is known,
         so the note opens on it — only on success, never on the error arm
         below, which knows no outcome. Not for a non-consultation (Nittin,
         2026-09-28) and not for the two "Not answered" outcomes, where nobody
         was reached (2026-09-25): "Add call note" still opens it by hand. */
      if (opensCallNote(ele, value)) setCallNoteFor(ele);
    };
    const onError = (err) => {
      setUpdatingStatusId(0);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.handleStatusUpdate(body, onResponse, onError);
  };

  const fetchLatestAptDetailsBeforeCancelOrNoShow = (appId, value) => {
    setUpdatingStatusId(appId);
    const onResponse = (res) => {
      if (
        res != null &&
        res.appointments != null &&
        res.appointments.length != 0
      ) {
        setStatusToBeApplied(value);
        if (
          value === NAVIGO_STATUS.CANCELLED ||
          value === NAVIGO_STATUS.NO_SHOW ||
          value === NAVIGO_STATUS.NOT_ELIGIBLE ||
          value === NAVIGO_STATUS.DECLINED
        ) {
          // Every status that reaches this function runs the restyled flow,
          // which applies statusToBeApplied rather than a hardcoded status.
          setAppToBeCancelledNewFlow(res.appointments[0]);
        } else {
          setAppToBeCancelled(res.appointments[0]);
          setShowCancelAppDialog(true);
        }
      }
      setUpdatingStatusId(0);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setUpdatingStatusId(0);
    };
    navigoDashboardUtils.fetchAppointments(
      {
        pageNum: 1,
        pageSize: 1,
        appointmentId: appId,
        statusOrderSort: true,
      },
      onResponse,
      onError,
    );
  };

  const handleSelectChange = (value, ele) => {
    if (
      value === NAVIGO_STATUS.CANCELLED ||
      value === NAVIGO_STATUS.NO_SHOW ||
      value === NAVIGO_STATUS.DECLINED ||
      value === NAVIGO_STATUS.NOT_ELIGIBLE
    ) {
      fetchLatestAptDetailsBeforeCancelOrNoShow(ele.id, value);
    } else {
      handleAppointmentStatusChange(value, ele);
    }
  };

  const resetValuesAfterCancelAppDialogCloses = () => {
    setAppToBeCancelled(null);
    setStatusToBeApplied(null);
    setShowCancelAppDialog(false);
    setCancelAppOption(CANCEL_APP_OPTION.NONE);
  };

  useEffect(() => {
    if (cancelAppOption === CANCEL_APP_OPTION.NONE) {
      resetValuesAfterCancelAppDialogCloses();
      return;
    }
    if (cancelAppOption === CANCEL_APP_OPTION.JUST_CANCEL) {
      handleAppointmentStatusChange(statusToBeApplied, appToBeCancelled);
      resetValuesAfterCancelAppDialogCloses();
    }
    if (
      cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITH_REFUND ||
      cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND
    ) {
      if (cancelAppOption === CANCEL_APP_OPTION.CANCEL_WITH_REFUND) {
        openRefundDialog({
          appointmentObj: appToBeCancelled,
          isOnlyRefund: false,
          forceRefund:
            appToBeCancelled.refundStatus ===
            REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE,
          newRefundStatus: REFUND_STATUS.ELIGIBLE_APPLICABLE,
          statusToBeApplied,
          onRefresh: onRefreshStatus,
        });
        resetValuesAfterCancelAppDialogCloses();
      } else {
        openRefundDialog({
          appointmentObj: appToBeCancelled,
          isOnlyRefund: false,
          forceRefund: false,
          newRefundStatus: REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE,
          statusToBeApplied,
          onRefresh: onRefreshStatus,
        });
        resetValuesAfterCancelAppDialogCloses();
      }
    }
  }, [cancelAppOption]);

  const getSPLocationState = (appointment) => {
    let body = {
      type: "state",
      planId: appointment?.planID,
      serviceId: appointment?.serviceID,
      serviceMode: appointment?.mode,
    };

    const onResponse = (res) => {
      setStateList(
        res == null || res.state == null || res.state.length == 0
          ? []
          : res.state,
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };
  const getSPLocationCity = () => {
    setLoading(true);
    let body = {
      type: "city",
      state: stateSelected,
      planId: appointment?.planID,
      serviceId: appointment?.serviceID,
      serviceMode: appointment?.mode,
    };

    const onResponse = (res) => {
      setCityList(
        res == null || res.city == null || res.city.length == 0 ? [] : res.city,
      );
      setLoading(false);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };
  const getSPLocationLocality = () => {
    setLoading(true);
    let body = {
      type: "locality",
      state: stateSelected,
      city: citySelected,
      planId: appointment?.planID,
      serviceId: appointment?.serviceID,
      serviceMode: appointment?.mode,
    };

    const onResponse = (res) => {
      setLocalityList(
        res == null || res.locality == null || res.locality.length == 0
          ? []
          : res.locality,
      );
      // getSPByLoc(stateSelected, citySelected, null);
      getServiceProvider({
        type: 3,
        lang: [],
        state: stateSelected,
        city: citySelected,
        locality: null,
      });
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    navigoDashboardUtils.getSPLocation(body, onResponse, onError);
  };
  const getLanguages = (appointment) => {
    let body = {
      planId: appointment?.planID,
      serviceId: appointment?.serviceID,
      serviceMode: appointment?.mode,
    };
    const onResponse = (res) => {
      setLanguageSelected([]);

      setLanguages(
        res == null ||
          res.length == 0 ||
          res.languages == null ||
          res.languages.length === 0
          ? []
          : res.languages,
      );
    };
    const onError = (err) => {
      setLanguageSelected([]);
      setLanguages([]);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getLanguages(body, onResponse, onError);
  };
  const getHomeSampleDates = (appointment) => {
    const onResponse = (res) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getHomeSampleDates(
      appointment?.patientID,
      appointment?.planID,
      onResponse,
      onError,
    );
  };
  let getServiceProviderOfApp = (appointment) => {
    let onResponse = (res) => {
      if (res != null) {
        setServiceProviderOfApp(res);
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getServiceProviderById(
      appointment?.serviceProviderID,
      onResponse,
      onError,
    );
  };
  const getAppointmentDocMapping = (appId) => {
    const onResponse = (res) => {
      if (res != undefined && res.documents.length > 0) {
        setAppDocMap(res.documents);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAppointmentDocMapping(appId, onResponse, onError);
  };
  // Jumps to the Appointment history card; that section only renders when there
  // are audits, so the ref can legitimately be empty.
  const scrollToAppointmentHistory = () => {
    if (appointmentHistoryRef.current != null) {
      appointmentHistoryRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const getAppointmentAudit = (appId) => {
    const onResponse = (res) => {
      setAppointmentAudits(
        Array.isArray(res?.appointmentAudits) ? res.appointmentAudits : [],
      );
      setRescheduleCount(Number(res?.rescheduleCount) || 0);
    };
    const onError = (err) => {
      setAppointmentAudits([]);
      setRescheduleCount(0);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAppointmentAudit(appId, onResponse, onError);
  };
  const fetchReasonsForConsultation = () => {
    const onResponse = (res) => {
      setReasonList(res.length != 0 ? res : []);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.fetchReasonsForConsultation(onResponse, onError);
  };
  const getDocumentFormat = (type) => {
    switch (type) {
      case "jpg":
      case "jpeg":
        return 1;
      case "png":
        return 2;
      case "gif":
        return 3;
      case "pdf":
        return 4;
      case "mp3":
        return 5;
      case "mp4":
        return 6;
      default:
        return 0;
    }
  };
  const handleUploadReportClick = () => {
    if (uploadFileRef && uploadFileRef.current) {
      uploadFileRef.current.click();
    }
  };
  const handleUploadFile = (e) => {
    if (e.target.files.length === 0) return;
    setIsUploadingDoc(true);
    let document = {
      title: "",
      description: "",
      url: "",
      type: 11,
      format: getDocumentFormat(e.target.files[0].name.split(".").pop()),
      status: 4,
    };
    if (appointment?.bookedFor != 0) {
      let body = {
        ...document,
      };
      document.type = 6;
      navigoDashboardUtils.uploadDocument(
        e.target.files[0],
        e.target.files[0].name,
        body,
        (res) => {
          navigoDashboardUtils.uploadDocumentDigital(
            {
              appointmentId: appointment?.id,
              documentId: res.id,
            },
            (res2) => {
              getAppointmentDocMapping(appointment?.id);
            },
            (err2) => {
              EventService.emit("showError", {
                message: `Error: ${err2?.message}`,
              });
            },
          );
          labtestAutomation(res);
        },
        (err) => {
          EventService.emit("showError", {
            message: `Error: ${err?.message}`,
          });
        },
        appointment?.bookedFor,
      );
    }
    navigoDashboardUtils.uploadDocument(
      e.target.files[0],
      e.target.files[0].name,
      document,
      (res) => {
        navigoDashboardUtils.uploadDocumentDigital(
          {
            appointmentId: appointment?.id,
            documentId: res.id,
          },
          (res2) => {
            getAppointmentDocMapping(appointment?.id);
            setIsUploadingDoc(false);
          },
          (err2) => {
            setIsUploadingDoc(false);
            EventService.emit("showError", {
              message: `Error: ${err2?.message}`,
            });
          },
        );
        labtestAutomation(res);
      },
      (err) => {
        setIsUploadingDoc(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
      appointment?.patientID,
    );
  };
  const labtestAutomation = (res) => {
    navigoDashboardUtils.uploadDocumentLabtestAutomation(
      {
        patientId: res.patientId,
        documentURL: res.url,
      },
      (res3) => {},
      (err3) => {
        EventService.emit("showError", {
          message: `Error: ${err3?.message}`,
        });
      },
    );
  };

  const generateDocumentToken = () => {
    patientService.getAndSaveDocumentToken(
      (response) => {
        localStorage.setItem("zy.bridge.doc.token", JSON.stringify(response));
        setToken(response.token);
      },
      (error) => {},
    );
  };
  const viewDocument = (url, token) => {
    if (url) {
      window.open(url + "?token=" + token.toString(), "_blank");
    }
  };

  // Recordings live in a private GCS bucket. document-service issues a signed
  // GET URL scoped to that one object for ~15 minutes; the browser streams it
  // directly, so it is set as the <audio> src rather than downloaded first.
  const playRecording = (recordingId) => {
    if (
      !recordingId ||
      recordingUrls[recordingId] ||
      loadingRecordingId === recordingId
    )
      return;
    setLoadingRecordingId(recordingId);

    navigoDashboardUtils.getCallRecordingSignedUrl(
      recordingId,
      (res) => {
        if (!res?.url) {
          setLoadingRecordingId(0);
          EventService.emit("showError", {
            message: `Unable to load the recording: no signed URL returned`,
          });
          return;
        }
        setRecordingUrls((prev) => ({ ...prev, [recordingId]: res.url }));
        setLoadingRecordingId(0);
      },
      (err) => {
        setLoadingRecordingId(0);
        EventService.emit("showError", {
          message: `Unable to load the recording: ${err?.message}`,
        });
      },
    );
  };

  // File extension (lower-cased, query-stripped) from a document URL.
  const getDocExtension = (url) => {
    if (!url) return "";
    const cleanUrl = url.split("?")[0];
    const parts = cleanUrl.split(".");
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
  };

  const isImageDocument = (url) =>
    ["png", "jpeg", "jpg"].includes(getDocExtension(url));

  // Force a download of the document. Fetches the file as a blob so the browser
  // saves it instead of navigating; falls back to opening in a new tab if the
  // blob fetch fails (e.g. CORS).
  const downloadDocument = (url, token, fileName) => {
    if (!url) return;
    const fullUrl = url + "?token=" + token.toString();
    const ext = getDocExtension(url);
    let name = fileName || "document";
    if (ext && !name.toLowerCase().endsWith(`.${ext}`)) {
      name = `${name}.${ext}`;
    }
    fetch(fullUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
      })
      .catch(() => {
        window.open(fullUrl, "_blank");
      });
  };

  // Both ways into the reschedule UI funnel through here, so a cart appointment can
  // never flip openRescheduleDialog — which is what keeps the provider fetch and the
  // non-cart slot fetch (both keyed on that flag) out of the cart path entirely.
  const openRescheduleUI = () => {
    if (isCartAppointment(appointment)) {
      setOpenCartReschedule(true);
    } else {
      setOpenRescheduleDialog(true);
    }
  };

  const checkPatientInfo = (pid) => {
    navigoDashboardUtils.fetchPatientId(
      pid,
      (res) => {
        if (res && res.id !== undefined) {
          setPatientInfo(res);
          if (isDOBEmpty(res) || isEmailEmpty(res)) {
            setUpdatePatientInfoDialog(true);
          } else {
            setUpdatePatientInfoDialog(false);
            openRescheduleUI();
          }
        }
      },
      (err) => {
        setPatientInfo(null);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const checkPatientInfoOnPageLoad = (pid) => {
    navigoDashboardUtils.fetchPatientId(
      pid,
      (res) => {
        if (res && res.id !== undefined) {
          setPatientInfoOnPageLoad(res);
        }
      },
      (err) => {
        setPatientInfoOnPageLoad(null);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const checkPrimaryPatientInfoOnPageLoad = (pid) => {
    navigoDashboardUtils.fetchPatientId(
      pid,
      (res) => {
        if (res && res.id !== undefined) {
          setPrimaryPatientInfoOnPageLoad(res);
        }
      },
      (err) => {
        setPrimaryPatientInfoOnPageLoad(null);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const closePatientInfoDialog = () => {
    setNewDob(null);
    setNewEmail("");
    setPatientInfo(null);
    setUpdatePatientInfoDialog(false);
  };
  const isDOBEmpty = (patient) => {
    const dob = patient?.dateOfBirth;
    return (
      dob === undefined ||
      dob === null ||
      dob === "" ||
      isNaN(dob) ||
      Number(dob) === 0
    );
  };

  const isEmailEmpty = (patient) => {
    const email = patient?.email;
    return (
      email === undefined ||
      email === null ||
      typeof email !== "string" ||
      email.trim() === ""
    );
  };
  const isValidEmail = (email) => {
    if (
      typeof email !== "string" ||
      email.trim() === "" ||
      !email.includes("@")
    ) {
      return false;
    }

    const [localPart, domain] = email.trim().split("@");

    if (!localPart || !domain) return false;

    const isValidEmailDomain = (domain) =>
      /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain);

    return isValidEmailDomain(domain);
  };

  const updatePatientInfo = (patient) => {
    if (isDOBEmpty(patient) && newDob === null) {
      EventService.emit("showError", {
        message: `Please fill the Date of birth`,
      });
      return;
    }
    if (
      isEmailEmpty(patient) &&
      newEmail !== "" &&
      isValidEmail(newEmail) === false
    ) {
      EventService.emit("showError", {
        message: `Please enter a valid email address`,
      });
      return;
    }
    const body = {
      patientId: patient.id,
      firstName: patient.firstName,
      lastName: patient.lastName ? patient.lastName : null,
      gender: patient.gender,
      dateOfBirth: isDOBEmpty(patient)
        ? moment(newDob).format("YYYY-MM-DD")
        : moment(patient.dateOfBirth).format("YYYY-MM-DD"),
      phoneNo: String(patient.phoneno),
      email: newEmail !== "" ? newEmail : patient.email,
      profileImage: patient.profileImage,
      countryCode: patient.countryCode,
    };

    const onResponse = (res) => {
      EventService.emit("showError", {
        message: `Information updated`,
      });
      setLoadingProfileUpdate(false);
      closePatientInfoDialog();
      openRescheduleUI();
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingProfileUpdate(false);
    };
    if (!isDOBEmpty(patient) && newEmail === "") {
      onResponse("");
    } else {
      setLoadingProfileUpdate(true);
      navigoDashboardUtils.updateProfileInfo(body, onResponse, onError);
    }
  };

  const exitPage = () => {
    setLoading(false);
    setAppointment(null);
    setReasonList(null);
    setIsMounted(false);
    setAppDocMap([]);
    setToken("");
    setHomeSampleDateMin(null);
    setHomeSampleDateMax(null);
    setStateList([]);
    setStateSelected(null);
    setCityList([]);
    setCitySelected(null);
    setLocalityList([]);
    setLocalitySelected(null);
    setLanguages([]);
    setLanguageSelected([]);
    setLocationModeSelected(null);
    setGeoLocData(null);
    setRangeOptionSelected(null);
    setAddressList([]);
    setAddressSelected(null);
    setServiceProviderOfApp(null);
    setPatientInfo(null);
    props.setView(0);
  };

  const resetValues = (code) => {
    // Every reset case clears the chosen date, so the 7-day strip always falls
    // back to the provider's earliest bookable week.
    setSlotRangeStartDate(null);
    setSlotBucketToggle({ dateKey: null, expanded: [] });
    switch (code) {
      case 1: // after closing dialog box
        setReasonSelected(null);
        setOtherReasonComment("");
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectServiceProviderCheckbox(false);
        setDateSelected(null);
        setSlotWindow(EMPTY_SLOT_WINDOW);
        setSlotSelected(null);
        setLoading(false);
        setLanguageSelected([]);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setLocationModeSelected(null);
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setOpenRescheduleDialog(false);
        break;
      case 2: // after language select or after state/city/locality selected
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectServiceProviderCheckbox(false);
        setDateSelected(null);
        setSlotWindow(EMPTY_SLOT_WINDOW);
        setSlotSelected(null);
        break;
      case 7: // after service provider change
        setDateSelected(null);
        setSlotWindow(EMPTY_SLOT_WINDOW);
        setSlotSelected(null);
        setLoading(false);
        break;
      case 10:
        setGeoLocData(null);
        setRangeOptionSelected(null);
        setAddressList([]);
        setAddressSelected(null);
        setStateSelected(null);
        setCityList([]);
        setCitySelected(null);
        setLocalityList([]);
        setLocalitySelected(null);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectServiceProviderCheckbox(false);
        setServiceProviderListToShow([]);
        setDateSelected(null);
        setSlotWindow(EMPTY_SLOT_WINDOW);
        setSlotSelected(null);
        break;
      case 11:
        setRangeOptionSelected(null);
        setServiceProviderSelected(null);
        setServiceProviderAutoSelected(null);
        setSelectServiceProviderCheckbox(false);
        setDateSelected(null);
        setSlotWindow(EMPTY_SLOT_WINDOW);
        setSlotSelected(null);
        break;
    }
  };

  const rescheduleAppointment = () => {
    if (reasonSelected == null) {
      EventService.emit("showError", {
        message: `Please select a reason for rescheduling`,
      });
      return;
    } else if (
      reasonSelected === OTHER_REASON &&
      otherReasonComment.trim() === ""
    ) {
      EventService.emit("showError", {
        message: `Please add a comment for the other reason`,
      });
      return;
    } else if (
      serviceProviderSelected == null &&
      selectServiceProviderCheckbox == false
    ) {
      EventService.emit("showError", {
        message: `Please select a service provider`,
      });
      return;
    } else if (dateSelected == null) {
      EventService.emit("showError", {
        message: `Please select a date`,
      });
      return;
    } else if (slotSelected == null) {
      EventService.emit("showError", {
        message: `Please select a time slot`,
      });
      return;
    } else {
      setLoading(true);
      let body = {
        appointmentID: appointment?.id,
        appointmentDate:
          moment(dateSelected).format("YYYY-MM-DD") + "T00:00:00.000Z",
        timeslot: slotSelected.value,
        timeSlotId: slotSelected.key,
        serviceProviderID: selectServiceProviderCheckbox
          ? serviceProviderAutoSelected
          : serviceProviderSelected?.id,
        reason:
          reasonSelected === OTHER_REASON
            ? otherReasonComment.trim()
            : reasonSelected,
        ...(props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && {
          selectL2Availability: true,
        }),
      };
      // Captured before resetValues() clears the selection, for the success dialog.
      const newSlotText = `${moment(dateSelected).format(
        "ddd, D MMM YYYY",
      )} · ${slotLabel(slotSelected)}`;
      const onResponse = (res) => {
        resetValues(1);
        setRescheduledSummary(newSlotText);
        setLoading(false);
        setOpenRescheduleDialog(false);
        // Same refresh a status change does: a reschedule also adds an audit
        // entry and bumps rescheduleCount, so the history table and the
        // "Rescheduled" count need re-fetching alongside the appointment.
        onRefreshStatus();
      };
      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };

      navigoDashboardUtils.rescheduleAppointment(body, onResponse, onError);
    }
  };

  const updateExtOrderId = () => {
    if (newExtOrderId.trim() === "") {
      EventService.emit("showError", {
        message: `Please enter new external order ID`,
      });
      return;
    } else {
      setLoading(true);
      const onResponse = (res) => {
        EventService.emit("showError", {
          message: `External order ID updated successfully`,
        });
        setNewExtOrderId("");
        setLoading(false);
        setUpdateExtOrderIdDialog(false);
        fetchAppointment();
        // props.resetDashboardReload();
      };
      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };

      navigoDashboardUtils.updateExtOrderId(
        appointment?.id,
        newExtOrderId,
        onResponse,
        onError,
      );
    }
  };

  const getPatientAddress = () => {
    const onResponse = (res) => {
      setAddressList(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getPatientAddress(
      appointment?.patientID,
      onResponse,
      onError,
    );
  };

  const getAvailCareDates = (pid, planId) => {
    const onResponse = (res) => {
      if (res != null) {
        setAvailCareDateMin(res.minBookingDays);
        setAvailCareDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err) => {
      setAvailCareDateMin(null);
      setAvailCareDateMax(null);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getAvailCareDates(pid, planId, onResponse, onError);
  };

  const fetchPriorityVendors = () => {
    const onResponse = (res) => {
      const ids =
        res == null || res.length === 0
          ? []
          : res.map((v) => v.mappedServiceProviderId);
      setPriorityVendorMappedSpIds(ids);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    navigoDashboardUtils.getPriorityVendors(onResponse, onError);
  };

  // Home Sample health checkup: a provider whose id matches a priority vendor's
  // mappedServiceProviderId uses the global booking config; every other
  // (non-priority) provider uses its own booking days.
  // Declared (not a const arrow) so it hoists with getMinDate / getMaxDate: the
  // reschedule date-strip derivations call those during render, well above this
  // point in the component body.
  function usesGlobalBookingConfig(serviceProviderSelected) {
    if (serviceProviderSelected == null) {
      return true;
    }
    return priorityVendorMappedSpIds.includes(serviceProviderSelected.id);
  }

  function getMinDate(
    appointment,
    homeSampleDateMin,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    if (appointment?.mode === MODES.HOME_SAMPLE) {
      if (
        appointment?.serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP &&
        !usesGlobalBookingConfig(serviceProviderSelected)
      ) {
        return serviceProviderSelected?.minBookingDays === undefined
          ? moment()
          : moment().add(serviceProviderSelected.minBookingDays, "days");
      }
      return homeSampleDateMin == null
        ? moment()
        : moment().add(homeSampleDateMin, "days");
    }
    if (
      appointment?.serviceTypeID === SERVICE_TYPE.CONSULTATION &&
      appointment?.serviceSubtypeID === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      if (availCareDateMin == null) {
        return moment();
      } else {
        return moment().add(availCareDateMin, "days");
      }
    }

    if (selectServiceProviderCheckbox) {
      return moment();
    }

    if (serviceProviderSelected?.minBookingDays === undefined) {
      return moment();
    }

    return moment().add(serviceProviderSelected.minBookingDays, "days");
  }

  function getMaxDate(
    appointment,
    homeSampleDateMax,
    selectServiceProviderCheckbox,
    serviceProviderSelected,
  ) {
    if (appointment?.mode === MODES.HOME_SAMPLE) {
      if (
        appointment?.serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP &&
        !usesGlobalBookingConfig(serviceProviderSelected)
      ) {
        return serviceProviderSelected?.maxBookingDays === undefined
          ? undefined
          : moment().add(serviceProviderSelected.maxBookingDays - 1, "days");
      }
      return homeSampleDateMax == null
        ? undefined
        : moment().add(homeSampleDateMax - 1, "days");
    }
    if (
      appointment?.serviceTypeID === SERVICE_TYPE.CONSULTATION &&
      appointment?.serviceSubtypeID === SERVICE_SUB_TYPE.AVAIL_CARE
    ) {
      if (availCareDateMax == null) {
        return undefined;
      } else {
        return moment().add(availCareDateMax - 1, "days");
      }
    }

    if (selectServiceProviderCheckbox) {
      return undefined;
    }

    if (serviceProviderSelected?.maxBookingDays === undefined) {
      return undefined;
    }

    return moment().add(serviceProviderSelected.maxBookingDays - 1, "days");
  }

  // Location Picker Dialog

  const { dialogState, setDialogState, openLocationDialog, closeDialog } =
    useLocationDialog();

  const handleOpenLocationPicker = async () => {
    const result = await openLocationDialog(geoLocData);

    if (result?.confirmed) {
      const { latLng, address, selectedLabel, query } = result;

      const dataToStore = {
        latLng,
        address,
        selectedLabel,
        query,
      };
      resetValues(11);
      setGeoLocData(dataToStore);
      setTimeout(() => {
        handleRadiusKmSelected(
          LOCATION_RANGE_KMS_OPTIONS[0],
          true,
          dataToStore.latLng,
        );
        // if (serviceTypeSelected.serviceTypeId === 1) {
        //   fetchLanguages([]);
        // } not required to fetch languages as in person does not need location filter in reschedule
      }, 0);
    } else {
    }
  };

  const getCoordinatesFromAddressId = (addressId) => {
    return new Promise((resolve, reject) => {
      const onResponse = (res) => {
        resolve(res);
      };

      const onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        reject(err);
      };

      navigoDashboardUtils.getCoordinatesFromAddressId(
        addressId,
        onResponse,
        onError,
      );
    });
  };

  const getLocationFromSavedAddress = async (addressSelected) => {
    if (!addressSelected) {
      setLoading(false);
      return;
    }

    let lat = null;
    let lng = null;

    const coords = addressSelected?.coordinates;

    // Case 1: Coordinates already exist and are valid
    if (
      coords &&
      typeof coords.latitude === "number" &&
      typeof coords.longitude === "number" &&
      !(coords.latitude === 0 && coords.longitude === 0)
    ) {
      lat = coords.latitude;
      lng = coords.longitude;
    }
    // Case 2: Need to fetch from API
    else {
      try {
        const res = await getCoordinatesFromAddressId(addressSelected?.id);

        lat = res?.latitude;
        lng = res?.longitude;

        if (
          typeof lat !== "number" ||
          typeof lng !== "number" ||
          (lat === 0 && lng === 0)
        ) {
          throw new Error("Invalid coordinates received");
        }
      } catch (error) {
        setLoading(false);
        setAddressSelected(null);
        return; // stop execution if API fails
      }
    }

    const dataToStore = {
      latLng: {
        lat,
        lng,
      },
      address: null,
      selectedLabel: null,
    };

    setGeoLocData(dataToStore);

    // Set address selected immediately after reset to avoid race conditions
    setAddressSelected(addressSelected);

    // Use setTimeout to ensure state updates are processed before fetching service providers
    setTimeout(() => {
      handleRadiusKmSelected(
        LOCATION_RANGE_KMS_OPTIONS[0],
        true,
        dataToStore.latLng,
      );
      // if (serviceTypeSelected.serviceTypeId === 1) {
      //   fetchLanguages([]);
      // }
    }, 0);
  };

  function formatAddress(address) {
    if (!address || typeof address !== "object") return "";

    const fieldsInOrder = [
      address.building,
      address.street,
      address.landmark,
      address.neighborhood,
      address.subLocality,
      address.localityArea,
      address.city,
      address.subDistrict,
      address.district,
      address.state,
      address.pincode,
      address.country,
    ];

    return fieldsInOrder
      .filter((value) => typeof value === "string" && value.trim().length > 0)
      .join(", ");
  }

  function handleRadiusKmSelected(rangeOpt, autocheck = false, latLng = null) {
    const radius = rangeOpt?.value;
    const hasValidRadius = Number.isFinite(radius) && radius > 0;
    const hasLatLng = latLng?.lat != null && latLng?.lng != null;

    if (!hasValidRadius || !hasLatLng) {
      setRangeOptionSelected(null);
      return;
    }

    setRangeOptionSelected(rangeOpt);
    getServiceProvider({
      type: 4,
      lang: [],
      state: null,
      city: null,
      locality: null,
      range: {
        latLng,
        radius,
        autocheck: Boolean(autocheck),
      },
    });
  }

  const formatDistanceKm = (distanceInMeters) => {
    if (typeof distanceInMeters !== "number") return "";
    return `${(distanceInMeters / 1000).toFixed(2)} km away`;
  };

  const startRescheduleFlow = () => {
    if (appointment?.patientID == null) return;
    const pid =
      appointment?.bookedFor === 0
        ? appointment?.patientID
        : appointment?.bookedFor;

    if (!isCartAppointment(appointment)) {
      checkPatientInfo(pid);
      return;
    }

    // Cart appointments only: a dry run that surfaces the cart-specific blockers (group
    // service disabled on the plan, provider no longer covering every test in the cart)
    // before we make the admin fill in a DOB/email or pick a slot. It writes nothing.
    setLoading(true);
    navigoDashboardUtils.rescheduleAppointment(
      { appointmentID: appointment?.id },
      () => {
        setLoading(false);
        checkPatientInfo(pid);
      },
      (err) => {
        setLoading(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
      true,
    );
  };

  const TrackPhlebotomistNote = ({ url }) => {
    const handleRedirect = () => {
      if (url) {
        window.open(url, "_blank");
      }
    };

    return (
      <div
        style={{
          backgroundColor: "#DDF6EB",
          border: "1px solid #1BC47D",
          padding: "10px 16px",
          borderRadius: "6px",
          marginBottom: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              color: "#000",
              wordBreak: "break-word",
            }}
          >
            Phlebotomist is on the way to collect sample,{" "}
            <span
              onClick={handleRedirect}
              style={{
                color: "#ef7c01",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              click here to track
            </span>
          </div>

          <div
            onClick={handleRedirect}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <img src={redirIcon} height={"20px"} alt="Redirect" />
          </div>
        </div>
      </div>
    );
  };

  // ---- Appointment summary section (top notes + status / payment / date) ----
  const summarySectionHeadingStyle = {
    color: "#494949",
    fontSize: "12px",
    fontWeight: 400,
    marginBottom: "8px",
  };
  // Status accent, mirroring the classes NavigoDashboard puts on its status
  // selector (.pending-class / .progress-class / .closed-class / .invalid-class
  // in navigoDashboardStyles.scss) so both screens read the same.
  const getStatusAccent = (status) => {
    // Every terminal status takes .closed-class. Keyed off END_STATUS_SET via
    // isEndStatus() rather than a hand-written list, so Completed, Cancelled,
    // Report generated, Successful HRA / PRC, Declined, Not eligible and No
    // show all match — and any status added to that set later follows suit.
    if (isEndStatus(status)) {
      return {
        color: "rgba(48, 197, 63, 1)",
        backgroundColor: "rgba(48, 197, 63, 0.1)",
      };
    }
    switch (status) {
      case NAVIGO_STATUS.CONFIRMED: // .invalid-class
        return { color: "#000000", backgroundColor: "rgba(0, 0, 0, 0.1)" };
      case NAVIGO_STATUS.IN_PROGRESS: // .pending-class
        return { color: "#FFBD2D", backgroundColor: "#FFF9E3" };
      default: // .progress-class — every other status
        return {
          color: "#EF7C01",
          backgroundColor: "rgba(239, 124, 1, 0.1)",
        };
    }
  };
  const summaryStatusAccent = getStatusAccent(appointment?.status);
  const summaryStatusPillStyle = {
    display: "inline-block",
    padding: "4px 8px",
    backgroundColor: summaryStatusAccent.backgroundColor,
    border: `1px solid ${summaryStatusAccent.color}`,
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "14px",
    color: summaryStatusAccent.color,
  };

  // Whether any of the conditional top notes are rendered above the info row.
  // Used to avoid doubling up the section's top padding with the row's margin.
  const hasSummaryTopNote =
    appointment?.paymentStatusResponse ===
      APPOINTMENT_PAYMENT_STATUS.INITIATED ||
    !!appointment?.phleboTrackingLink ||
    (isEndStatusCancelled(appointment?.status) &&
      appointment?.paymentStatusResponse ===
        APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED);

  // Payment / refund status pills. Derived in paymentViewModel so this note and
  // the payment details card below always show the same thing.
  const paymentStatusDisplay = getPaymentStatusDisplay(appointment);
  const showPaymentStatusSection = paymentStatusDisplay.show;
  const paymentStatusLabel = paymentStatusDisplay.label;
  const paymentStatusColor = paymentStatusDisplay.color;
  const refundStatusDisplay = getRefundStatusDisplay(appointment);
  const showRefundStatusSection = refundStatusDisplay.show;

  // The status pill is a dropdown when the appointment is still in progress, or
  // when it's a completed gym appointment (which can still be cancelled) —
  // matching NavigoDashboard's editable/non-editable status rules.
  const isGymCompletedEditable =
    isEndStatus(appointment?.status) &&
    appointment?.status === NAVIGO_STATUS.COMPLETED &&
    appointment?.serviceTypeID === SERVICE_TYPE.GYM;
  const isStatusEditable =
    !isEndStatus(appointment?.status) || isGymCompletedEditable;

  // The list of statuses shown in the pill dropdown, mirroring the MenuItems in
  // NavigoDashboard's status <Select>.
  const buildStatusMenuOptions = () => {
    if (isGymCompletedEditable) {
      return [
        { value: NAVIGO_STATUS.COMPLETED, name: "Completed", disabled: true },
        { value: NAVIGO_STATUS.CANCELLED, name: "Cancel" },
      ];
    }
    const status = appointment?.status;
    const mode = appointment?.mode;
    const serviceTypeID = appointment?.serviceTypeID;
    const options = [];
    if (mode != MODES.HOME_SAMPLE) {
      options.push({
        value: NAVIGO_STATUS.SCHEDULED_LEGACY,
        name: "Scheduled",
        disabled:
          status == NAVIGO_STATUS.COMPLETED ||
          status === NAVIGO_STATUS.RESCHEDULE_REQUESTED,
      });
    }
    if (serviceTypeID !== SERVICE_TYPE.GYM && mode != MODES.HOME_SAMPLE) {
      hraStatuses
        .filter((st) => !LAB_WORKFLOW_STATUSES.includes(st.value))
        .forEach((st) => options.push({ value: st.value, name: st.name }));
    }
    if (mode === MODES.HOME_SAMPLE) {
      navigoLabtestStatus
        .filter((st) => st.value != NAVIGO_STATUS.RESCHEDULE_REQUESTED)
        .forEach((st) => options.push({ value: st.value, name: st.name }));
    }
    if (serviceTypeID !== SERVICE_TYPE.GYM) {
      options.push({
        value: NAVIGO_STATUS.NO_SHOW,
        name: "No show",
        disabled: status === NAVIGO_STATUS.RESCHEDULE_REQUESTED,
      });
    }
    if (serviceTypeID === SERVICE_TYPE.GYM) {
      options.push({
        value: NAVIGO_STATUS.COMPLETED,
        name: "Completed",
        disabled: status === NAVIGO_STATUS.RESCHEDULE_REQUESTED,
      });
    }
    options.push({ value: NAVIGO_STATUS.CANCELLED, name: "Cancelled" });
    return options;
  };

  // Appointment date is treated as "unset" when it is null or the unix epoch (01 Jan 1970).
  const appointmentDateMoment = appointment?.appointmentDate
    ? moment(appointment.appointmentDate)
    : null;
  const showAppointmentDateTime =
    appointmentDateMoment != null &&
    appointmentDateMoment.isValid() &&
    appointmentDateMoment.year() !== 1970;
  // Appointment time range: start from timeSlot, end = start + serviceDuration
  // (when serviceDuration is present). AM/PM is shown only after the end time,
  // unless the duration is >= 720 mins in which case both times carry AM/PM.
  const appointmentTimeText = (() => {
    const slotStart = appointment?.timeSlot ?? 0;
    const serviceDuration = appointment?.serviceDuration;
    const startMoment = moment().startOf("day").add(slotStart, "minutes");
    if (serviceDuration == null || serviceDuration <= 0) {
      return startMoment.format("hh:mm A");
    }
    const endMoment = moment()
      .startOf("day")
      .add(slotStart + serviceDuration, "minutes");
    return serviceDuration >= 720
      ? `${startMoment.format("hh:mm A")} - ${endMoment.format("hh:mm A")}`
      : `${startMoment.format("hh:mm")} - ${endMoment.format("hh:mm A")}`;
  })();
  const appointmentDateTimeText = showAppointmentDateTime
    ? `${moment(appointment?.appointmentDate?.slice(0, 10)).format(
        "DD MMM YYYY",
      )}, ${appointmentTimeText}`
    : "";

  // ---- Reschedule dialog: date strip + slot labels ----
  // Builds a slot label from its start (minutes from midnight); the end is
  // start + the appointment's service duration (same rules as the top note).
  const formatSlotRange = (startMinutes) => {
    const serviceDuration = appointment?.serviceDuration;
    const startMoment = moment().startOf("day").add(startMinutes, "minutes");
    if (serviceDuration == null || serviceDuration <= 0) {
      return startMoment.format("h:mm A");
    }
    const endMoment = moment()
      .startOf("day")
      .add(startMinutes + serviceDuration, "minutes");
    return serviceDuration >= 720
      ? `${startMoment.format("h:mm A")} - ${endMoment.format("h:mm A")}`
      : `${startMoment.format("h:mm")} - ${endMoment.format("h:mm A")}`;
  };
  // The slots API sends a ready-made label ("9:00 - 9:30 AM"); formatSlotRange
  // is the fallback for responses that don't carry one.
  const slotLabel = (slot) =>
    slot?.label != null && slot.label !== ""
      ? slot.label
      : formatSlotRange(slot?.value);

  // ---- User details / Appointment details cards ----
  // NOTE: When these two sections were redesigned into side-by-side cards, the
  // following previously-shown fields were intentionally DROPPED:
  //   - User details      : "Patient phone number"
  //   - Appointment details: "Price", "Patient calling number"
  // "Reason for consultation" and "Reason description" are retained (tele/video
  // modes only). If any dropped field needs to come back, re-add it as a
  // renderDetailItem() entry in the matching card below.
  const detailsCardStyle = {
    flex: 1,
    minWidth: 0,
    border: "2px solid #D9D9D9",
    borderRadius: "16px",
    padding: "32px",
  };
  const detailsHeadingStyle = {
    color: "#000000",
    fontWeight: 700,
    fontSize: "24px",
  };
  const detailLabelStyle = {
    color: "#494949",
    fontWeight: 400,
    fontSize: "12px",
    marginBottom: "4px",
  };
  const detailValueStyle = {
    color: "#26284D",
    fontWeight: 400,
    fontSize: "16px",
    // break-word lets an over-long value break to fit its cell without
    // shrinking the cell's intrinsic width, so flex-wrap still pushes the
    // right-hand field to the next line when the left value is long.
    overflowWrap: "break-word",
  };
  // flexWrap + content-sized cells: when the left value is too wide to share a
  // line, the right field wraps below instead of overlapping it.
  const detailRowStyle = { display: "flex", flexWrap: "wrap", gap: "24px" };
  const detailsBodyStyle = {
    marginTop: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  };

  // ---- Appointment history / Call history tables ----
  const auditHeaderCellStyle = {
    padding: "14px 16px",
    color: "#757575",
    fontWeight: 600,
    fontSize: "12px",
    textAlign: "left",
    whiteSpace: "nowrap",
    border: "1px solid #D9D9D9",
  };
  const callHeaderCellStyle = { ...auditHeaderCellStyle, fontWeight: 500 };
  // The Recording cell swaps a short "Play recording" button for the browser's
  // <audio> player (~300px), so the column is pinned wide enough for the player
  // up front — otherwise the table re-lays-out and jitters on first play.
  const recordingColumnWidth = "320px";
  const historyBodyCellStyle = {
    padding: "14px 16px",
    color: "#000000",
    fontWeight: 400,
    fontSize: "12px",
    verticalAlign: "middle",
    overflowWrap: "break-word",
    border: "1px solid #D9D9D9",
  };
  // Call history events, present only on appointments that carry callData.
  const callEvents = Array.isArray(appointment?.callData?.events)
    ? appointment.callData.events
    : [];
  // Answered/missed get a coloured dot + matching text; anything else renders
  // as plain text.
  const dispositionColor = (disposition) => {
    const value = String(disposition ?? "").toLowerCase();
    if (value === "answered") return "#21A35C";
    if (value === "missed") return "#E5474D";
    return null;
  };
  const auditBubbleStyle = {
    height: "26px",
    width: "26px",
    borderRadius: "50%",
    backgroundColor: "#735CEB",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  // A single label/value cell. Each cell flex-grows: one cell per row fills the
  // full width, two cells per row split it in half.
  const renderDetailItem = (label, value) => (
    <div style={{ flex: 1 }}>
      <div style={detailLabelStyle}>{label}</div>
      <div style={detailValueStyle}>{value}</div>
    </div>
  );

  // Round "open in Google Maps" affordance shown beside an address. Renders
  // nothing when there's no link to open.
  const renderDirectionButton = (url) =>
    url ? (
      <button
        type="button"
        title="Open in Google Maps"
        onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
        style={{
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: "36px",
          width: "36px",
          borderRadius: "50%",
          border: "none",
          backgroundColor: "#F97F0F26",
          cursor: "pointer",
        }}
      >
        <RiDirectionLine size={22} color="#F97F0F" />
      </button>
    ) : null;

  // An address cell with the direction button pinned to the right of its value.
  const renderAddressItem = (label, address, mapUrl) => (
    <div style={{ flex: 1 }}>
      <div style={detailLabelStyle}>{label}</div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={detailValueStyle}>{address}</span>
        {renderDirectionButton(mapUrl)}
      </div>
    </div>
  );

  const patientIdValue =
    appointment?.bookedFor == 0
      ? appointment?.patientID
      : appointment?.bookedFor;
  // Gender shown in the Profile details dialog.
  const profileGenderValue =
    appointment?.patientGender === 1
      ? "Female"
      : appointment?.patientGender === 2
        ? "Male"
        : "Unknown";
  // Age/gender mask: the age keeps its digit count, but the gender is always
  // four X whether it reads "Male" or "Female", so the mask's width can't give
  // the gender away — both "(30) Male" and "(30) Female" -> "(XX) XXXX".
  // This value is never unmasked in the card; the real age and gender are shown
  // in the Profile details dialog instead.
  const maskedAgeAndGenderValue = `(${"X".repeat(
    String(appointment?.patientAge ?? "").length,
  )}) XXXX`;
  // ---- Profile details dialog ----
  const profileLabelStyle = {
    fontWeight: 400,
    color: "#8C94A1",
    fontSize: "13px",
    marginBottom: "4px",
  };
  const profileValueStyle = {
    color: "#1B1E28",
    fontWeight: 500,
    fontSize: "15px",
  };
  const USER_TYPE_MAP = {
    0: "Default",
    1: "Premium",
    2: "HR representative",
    3: "QA",
    4: "Sensitive",
  };
  const userTypeValue =
    USER_TYPE_MAP[appointment?.patientProfileType] ?? "Default";
  const userAddressValue =
    userAddress == null
      ? ""
      : [
          userAddress?.line1,
          userAddress?.line2,
          userAddress?.landmark,
          userAddress?.city,
          userAddress?.district,
          userAddress?.state,
          userAddress?.pincode ? ` (${userAddress.pincode})` : null,
        ]
          .filter(Boolean)
          .join(", ");
  // Maps link for the user's address, only when both coordinates are present
  // and non-zero.
  const userAddressMapLink =
    Number(userAddress?.coordinates?.latitude) &&
    Number(userAddress?.coordinates?.longitude)
      ? `https://www.google.com/maps?q=${userAddress.coordinates.latitude},${userAddress.coordinates.longitude}`
      : "";
  const appointmentDateValue =
    appointment?.serviceTypeID == SERVICE_TYPE.GYM
      ? "NA"
      : moment(appointment?.appointmentDate?.slice(0, 10)).format(
          "DD MMM YYYY",
        );
  // Time slot start–end range (end derived from serviceDuration), matching the
  // top-note format via appointmentTimeText.
  const timeSlotValue =
    appointment?.serviceTypeID == SERVICE_TYPE.GYM ? "NA" : appointmentTimeText;
  /* NOT `isConsultation` (appointmentConstants, used by the call-note rule
     below): this asks whether the consultation happens over a CALL, so In
     person is deliberately absent and it never looks at serviceTypeID. Don't
     collapse the two. */
  const isConsultationMode =
    appointment?.mode === MODES.TELE_CONSULTATION ||
    appointment?.mode === MODES.VIDEO_CONSULTATION;

  // Most recent updatedAt across all appointment documents (e.g. "5 Feb 2026").
  const documentsLastUpdatedText =
    appDocMap.length > 0
      ? moment(
          Math.max(...appDocMap.map((d) => moment(d.updatedAt).valueOf())),
        ).format("D MMM YYYY")
      : "";

  // ---- Service details / Service provider details cards ----
  // Service subtype keeps its original visibility: hidden for health-checkup
  // and vaccine services. When hidden, Service code + Service name share a line.
  const consultationGoogleMapLink = appointment?.serviceProviderGoogleMapLink
    ? appointment?.serviceProviderGoogleMapLink
    : (serviceProviderOfApp?.consultationInfo?.address?.googleMapLink ?? "");
  const nonConsultationGoogleMapLink = appointment?.serviceProviderGoogleMapLink
    ? appointment.serviceProviderGoogleMapLink
    : serviceProviderOfApp?.serviceTypeId === SERVICE_TYPE.HEALTH_CHECKUP
      ? (serviceProviderOfApp?.checkupInfo?.address?.googleMapLink ?? "")
      : serviceProviderOfApp?.serviceTypeId === SERVICE_TYPE.VACCINE
        ? (serviceProviderOfApp?.vaccineInfo?.address?.googleMapLink ?? "")
        : "";

  // Service code links to the service in View mode (CreateService, mode == 2),
  // opened in a new tab via ServiceModule's existing query-param deep link.
  const renderServiceCodeItem = () => (
    <div style={{ flex: 1 }}>
      <div style={detailLabelStyle}>{`Service code`}</div>
      <a
        href={`/service_module?view=2&mode=view&serviceId=${appointment?.serviceID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...detailValueStyle,
          textDecorationLine: "underline",
          textDecorationColor: "#F97F0F",
          textUnderlineOffset: "25%",
          textDecorationThickness: "11%",
          cursor: "pointer",
        }}
      >
        {appointment?.serviceCode}
      </a>
    </div>
  );

  // Service provider ID links to the provider in View mode
  // (CreateServiceProvider, view == 5), opened in a new tab via ServiceModule's
  // query-param deep link.
  const renderServiceProviderIdItem = () => (
    <div style={{ flex: 1 }}>
      <div style={detailLabelStyle}>{`Service provider ID`}</div>
      <a
        href={`/service_module?view=5&mode=view&serviceProviderId=${appointment?.serviceProviderID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...detailValueStyle,
          textDecorationLine: "underline",
          textDecorationColor: "#F97F0F",
          textUnderlineOffset: "25%",
          textDecorationThickness: "11%",
          cursor: "pointer",
        }}
      >
        {appointment?.serviceProviderID}
      </a>
    </div>
  );

  return !isMounted ? (
    <>
      <GlobalSkeletonLoader />
    </>
  ) : (
    <div className="navigo-module-page-padding">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="navigo-module-view">
            <div className="navigo-module-heading-with-back-button">
              <div
                className="navigo-module-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
              </div>
              <h1>{`Appointment details`}</h1>
            </div>
            <div className="navigo-module-buttons-container">
              <div className="navigo-module-buttons-right-alignment">
                {isMounted &&
                (appointment?.blockRescheduling === true ||
                  appointment?.serviceTypeID == SERVICE_TYPE.GYM ||
                  isEndStatus(appointment?.status)) ? (
                  <></>
                ) : (
                  <button
                    id="reschedule_button"
                    type="button"
                    disabled={loading}
                    className="rsd-reschedule-btn"
                    onClick={() => {
                      startRescheduleFlow();
                    }}
                  >
                    {"Reschedule"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      <div
        style={{
          width: "100%",
          border: "2px solid #D9D9D9",
          padding: "16px 26px",
          marginBottom: "16px",
          borderRadius: "16px",
        }}
      >
        {appointment?.paymentStatusResponse ===
          APPOINTMENT_PAYMENT_STATUS.INITIATED &&
          (isEndStatus(appointment?.status) ? (
            <TopNote
              text={`Note: Payment is still pending. Please complete it before ${moment(appointment?.paymentDetails?.paymentLink?.expireAt).format("hh:mm A")} (i.e. within ${appointment?.paymentDetails?.paymentLink?.linkValidMins} minutes of payment link generation)`}
              color="#E4443726"
              borderColor="#E44437"
              borderWidth="3px"
              textColor="#26284D"
              fontSize="14px"
              borderRadius="6.39px"
              padding="12.78px 16px"
            />
          ) : (
            <TopNote
              text={`Note: This appointment will be cancelled if payment is not received by ${moment(appointment?.paymentDetails?.paymentLink?.expireAt).format("hh:mm A")} (i.e. within ${appointment?.paymentDetails?.paymentLink?.linkValidMins} minutes of payment link generation)`}
              color="#E4443726"
              borderColor="#E44437"
              borderWidth="3px"
              textColor="#26284D"
              fontSize="14px"
              borderRadius="6.39px"
              padding="12.78px 16px"
            />
          ))}
        {appointment?.phleboTrackingLink && (
          <TrackPhlebotomistNote url={appointment.phleboTrackingLink} />
        )}
        {isEndStatusCancelled(appointment?.status) &&
          appointment?.paymentStatusResponse ===
            APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED &&
          (appointment?.paymentDetails?.paymentLink?.link ? (
            <TopNote
              text={`Note: This appointment is cancelled due to payment not received by ${moment(appointment?.paymentDetails?.paymentLink?.expireAt).format("hh:mm A")} (i.e. within ${appointment?.paymentDetails?.paymentLink?.linkValidMins} minutes of payment link generation)`}
              color="#E54336"
              borderColor="#E54336"
              textColor="#FFFFFF"
              fontSize="14px"
              borderRadius="6.39px"
              padding="12.78px 16px"
            />
          ) : (
            <TopNote
              text={`Note: This appointment is cancelled due to payment not received (Payment link was not generated)`}
              color="#E54336"
              borderColor="#E54336"
              textColor="#FFFFFF"
              fontSize="14px"
              borderRadius="6.39px"
              padding="12.78px 16px"
            />
          ))}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            marginTop: hasSummaryTopNote ? "16px" : 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "48px",
            }}
          >
            <div>
              <div
                style={summarySectionHeadingStyle}
              >{`Appointment status`}</div>
              {isStatusEditable ? (
                <>
                  <div
                    style={{
                      ...summaryStatusPillStyle,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor:
                        updatingStatusId === appointment?.id
                          ? "default"
                          : "pointer",
                    }}
                    onClick={(e) => {
                      if (updatingStatusId === appointment?.id) return;
                      setStatusMenuAnchor(e.currentTarget);
                    }}
                  >
                    {getStatusName(appointment?.status)}
                    <MdOutlineKeyboardArrowDown
                      style={{
                        fontSize: "18px",
                        color: summaryStatusAccent.color,
                      }}
                    />
                  </div>
                  <Menu
                    anchorEl={statusMenuAnchor}
                    open={Boolean(statusMenuAnchor)}
                    onClose={() => setStatusMenuAnchor(null)}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                  >
                    {buildStatusMenuOptions().map((opt) => (
                      <MenuItem
                        key={opt.value}
                        value={opt.value}
                        disabled={opt.disabled}
                        selected={opt.value === appointment?.status}
                        onClick={() => {
                          setStatusMenuAnchor(null);
                          if (opt.value !== appointment?.status) {
                            handleSelectChange(opt.value, appointment);
                          }
                        }}
                        style={{ fontWeight: 600, fontFamily: "Montserrat" }}
                      >
                        {opt.name}
                      </MenuItem>
                    ))}
                  </Menu>
                </>
              ) : (
                <div style={summaryStatusPillStyle}>
                  {getStatusName(appointment?.status)}
                </div>
              )}
            </div>
            {showPaymentStatusSection && (
              <div>
                <div style={summarySectionHeadingStyle}>{`Payment status`}</div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: paymentStatusColor,
                  }}
                >
                  {paymentStatusLabel}
                </div>
              </div>
            )}
            {showRefundStatusSection && (
              <div>
                <div style={summarySectionHeadingStyle}>{`Refund status`}</div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: refundStatusDisplay.color,
                  }}
                >
                  {refundStatusDisplay.label}
                </div>
              </div>
            )}
            {showAppointmentDateTime && (
              <div>
                <div
                  style={summarySectionHeadingStyle}
                >{`Appointment date & time`}</div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#26284D",
                  }}
                >
                  {appointmentDateTimeText}
                </div>
              </div>
            )}
            {rescheduleCount > 0 && (
              <div>
                <div style={summarySectionHeadingStyle}>{`Rescheduled`}</div>
                {/* The count links down to the Appointment history table, where
                    each reschedule is listed as its own audit row. */}
                <div
                  onClick={scrollToAppointmentHistory}
                  style={{
                    display: "inline-block",
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#26284D",
                    textDecorationLine: "underline",
                    textDecorationColor: "#F97F0F",
                    textUnderlineOffset: "25%",
                    textDecorationThickness: "11%",
                    cursor: "pointer",
                  }}
                >
                  {`${rescheduleCount} ${
                    rescheduleCount === 1 ? "time" : "times"
                  }`}
                </div>
              </div>
            )}
          </div>
          <CallPatientOptions appointment={appointment} />
        </div>
      </div>
      <br />
      <div className="navigo-module-create-service-container">
        <div style={{ display: "flex", gap: "16px", alignItems: "stretch" }}>
          {/* ---- User details card ---- */}
          <div style={detailsCardStyle}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "8px",
              }}
            >
              <div style={detailsHeadingStyle}>{`User details`}</div>
              <button
                type="button"
                title="Profile details"
                onClick={(e) => setUserMenuAnchor(e.currentTarget)}
                style={{
                  flexShrink: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "32px",
                  width: "32px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <RiMore2Fill size={20} color="#1B1E28" />
              </button>
              <Menu
                anchorEl={userMenuAnchor}
                open={Boolean(userMenuAnchor)}
                onClose={() => setUserMenuAnchor(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                {/* Single option; picking it closes the menu and opens the
                    Profile details dialog. */}
                <MenuItem
                  onClick={() => {
                    setUserMenuAnchor(null);
                    setProfileDialogOpen(true);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: "13px",
                    color: "#1B1E28",
                  }}
                >
                  <RiEyeLine size={16} color="#1B1E28" />
                  {`View profile details`}
                </MenuItem>
              </Menu>
            </div>
            <div style={detailsBodyStyle}>
              <div style={detailRowStyle}>
                <div style={{ flex: 1 }}>
                  <div style={detailLabelStyle}>{`Patient ID`}</div>
                  {/* Opens that patient's Health records — bridge's phr record,
                      /patient-record/:patientId (App.js) — in the SAME tab
                      (Nittin, 2026-09-21); it used to open the legacy
                      /patients/{id}/new-bridge screen in a new one. A router
                      Link: an in-app push, still an <a> to middle-click or copy. */}
                  {/* …carrying THIS appointment, so a health plan or an Rx
                      created from the record it opens is mapped back to it
                      (Nittin, 2026-09-28). A query param, not router state:
                      Create Rx can open in a new tab, which state does not
                      survive. */}
                  <Link
                    to={`/patient-record/${patientIdValue}${
                      appointment && appointment.id
                        ? `?appointmentId=${appointment.id}`
                        : ""
                    }`}
                    style={{
                      ...detailValueStyle,
                      textDecorationLine: "underline",
                      textDecorationColor: "#F97F0F",
                      textUnderlineOffset: "25%",
                      textDecorationThickness: "10%",
                      cursor: "pointer",
                    }}
                  >
                    {patientIdValue}
                  </Link>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={detailLabelStyle}>{`Booked for`}</div>
                  <span style={detailValueStyle}>
                    {appointment?.patientName}
                  </span>
                </div>
              </div>
              <div style={detailRowStyle}>
                <div style={{ flex: 1 }}>
                  <div style={{ ...detailLabelStyle, color: "#757575" }}>
                    {`Age and Gender`}
                  </div>
                  <div style={detailValueStyle}>{maskedAgeAndGenderValue}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ ...detailLabelStyle, color: "#757575" }}>
                    {`User type`}
                  </div>
                  <div style={detailValueStyle}>{userTypeValue}</div>
                </div>
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(`Account code`, appointment?.accountCode)}
                {renderDetailItem(`Account name`, appointment?.accountName)}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(
                  `Plan`,
                  `${appointment?.planID} - ${appointment?.planName}`,
                )}
              </div>
              {/* Base plan is only meaningful when the appointment was booked on
                  a plan derived from another one, so it stays hidden when unset
                  or when it just repeats the plan above. */}
              {appointment?.basePlanId > 0 &&
                appointment?.basePlanId !== appointment?.planID && (
                  <div style={detailRowStyle}>
                    {renderDetailItem(
                      `Base plan`,
                      appointment?.basePlanName
                        ? `${appointment?.basePlanId} - ${appointment?.basePlanName}`
                        : `${appointment?.basePlanId}`,
                    )}
                  </div>
                )}
            </div>
          </div>

          {/* ---- Appointment details card ---- */}
          <div style={detailsCardStyle}>
            <div style={detailsHeadingStyle}>{`Appointment details`}</div>
            <div style={detailsBodyStyle}>
              <div style={detailRowStyle}>
                {renderDetailItem(`Appointment ID`, appointment?.id)}
                <div style={{ flex: 1 }}>
                  <div style={detailLabelStyle}>{`External order ID`}</div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <span style={detailValueStyle}>
                      {appointment?.externalOrderId
                        ? appointment.externalOrderId
                        : "-"}
                    </span>
                    <Button
                      icon
                      style={{
                        cursor: "pointer",
                        flexShrink: 0,
                        width: "40px",
                        minWidth: "40px",
                        height: "40px",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setUpdateExtOrderIdDialog(true);
                        setNewExtOrderId(appointment?.externalOrderId ?? "");
                      }}
                    >
                      <FontIcon
                        style={{
                          color: "#EF7C01",
                          display: "block",
                          lineHeight: "1",
                        }}
                      >
                        {"edit"}
                      </FontIcon>
                    </Button>
                  </div>
                </div>
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(
                  `Appointment booked by`,
                  appointment?.bookedBy ?? "",
                )}
                {renderDetailItem(
                  `Creation date`,
                  moment(appointment?.createdAt).format("DD MMM YYYY"),
                )}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(`Appointment date`, appointmentDateValue)}
                {renderDetailItem(`Time slot`, timeSlotValue)}
              </div>
              {appointment?.mode === MODES.HOME_SAMPLE && (
                <div style={detailRowStyle}>
                  {renderAddressItem(
                    `User's Address`,
                    userAddressValue,
                    userAddressMapLink,
                  )}
                </div>
              )}
              {isConsultationMode && (
                <>
                  <div style={detailRowStyle}>
                    {renderDetailItem(
                      `Reason for consultation`,
                      reasonList.find((e) => e.id == appointment?.reasonId)
                        ?.name ?? "",
                    )}
                  </div>
                  <div style={detailRowStyle}>
                    {/* Rendered inline rather than via renderDetailItem: the
                        reason is free text and can run very long, so this one
                        value is capped and scrolls instead of stretching the
                        card. */}
                    <div style={{ flex: 1 }}>
                      <div style={detailLabelStyle}>{`Reason description`}</div>
                      <div
                        style={{
                          ...detailValueStyle,
                          maxHeight: "96px",
                          overflowY: "auto",
                        }}
                      >
                        {appointment?.reasonDetails || ""}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* ~3 & ~4: Service details + Service provider details (50% each) */}
        <div
          style={{
            display: "flex",
            gap: "16px",
            alignItems: "stretch",
            marginTop: "16px",
          }}
        >
          {/* ---- Service details card ---- */}
          <div style={detailsCardStyle}>
            <div style={detailsHeadingStyle}>{`Service details`}</div>
            <div style={detailsBodyStyle}>
              <div style={detailRowStyle}>
                {renderDetailItem(`Service ID`, appointment?.serviceID)}
                {renderDetailItem(`Service type`, appointment?.serviceTypeName)}
              </div>
              <div style={detailRowStyle}>
                <div style={{ flex: 1 }}>
                  <div style={{ ...detailLabelStyle, color: "#757575" }}>
                    {`Service sub type`}
                  </div>
                  <div style={detailValueStyle}>
                    {appointment?.serviceSubtypeName
                      ? appointment.serviceSubtypeName
                      : "-"}
                  </div>
                </div>
                {renderServiceCodeItem()}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(`Service name`, appointment?.serviceName)}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(`Service mode`, appointment?.mode)}
              </div>
            </div>
          </div>

          {/* ---- Service provider details card ---- */}
          <div style={detailsCardStyle}>
            <div style={detailsHeadingStyle}>{`Service provider details`}</div>
            <div style={detailsBodyStyle}>
              {appointment?.serviceTypeID == SERVICE_TYPE.CONSULTATION && (
                <>
                  <div style={detailRowStyle}>
                    {renderServiceProviderIdItem()}
                    {renderDetailItem(
                      `External provider ID/code`,
                      `${
                        appointment?.vendorDoctorId == 0
                          ? ""
                          : appointment?.vendorDoctorId
                      }`,
                    )}
                  </div>
                  <div style={detailRowStyle}>
                    {renderDetailItem(
                      `Service provider name`,
                      `${appointment?.serviceProviderName}`,
                    )}
                  </div>
                  <div style={detailRowStyle}>
                    {renderAddressItem(
                      `Service provider address`,
                      appointment?.serviceProviderAddress ?? "",
                      consultationGoogleMapLink,
                    )}
                  </div>
                </>
              )}
              {(appointment?.serviceTypeID == SERVICE_TYPE.HEALTH_CHECKUP ||
                appointment?.serviceTypeID == SERVICE_TYPE.VACCINE ||
                appointment?.serviceTypeID == SERVICE_TYPE.GYM ||
                appointment?.serviceTypeID == SERVICE_TYPE.DENTAL) && (
                <>
                  <div style={detailRowStyle}>
                    {renderServiceProviderIdItem()}
                  </div>
                  <div style={detailRowStyle}>
                    {renderDetailItem(
                      `Service provider name`,
                      appointment?.serviceProviderName,
                    )}
                  </div>
                  <div style={detailRowStyle}>
                    {renderAddressItem(
                      `Service provider address`,
                      appointment?.serviceProviderAddress ?? "",
                      nonConsultationGoogleMapLink,
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {Boolean(appointment?.serviceTypeID == SERVICE_TYPE.GYM) && (
          <div style={{ ...detailsCardStyle, marginTop: "16px" }}>
            <div style={detailsHeadingStyle}>{`Gym subscription details`}</div>
            <div style={detailsBodyStyle}>
              <div style={detailRowStyle}>
                {renderDetailItem(
                  `Base city`,
                  appointment?.gymMetadata?.city ?? "",
                )}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(
                  `Subscription mobile number`,
                  `+${appointment?.gymMetadata?.countryCode ?? ""} ${
                    appointment?.gymMetadata?.phoneNo ?? ""
                  }`,
                )}
              </div>
              <div style={detailRowStyle}>
                {renderDetailItem(
                  `Subscription Email ID`,
                  appointment?.gymMetadata?.email ?? "",
                )}
              </div>
            </div>
          </div>
        )}

        {/* Cart details section */}
        {cartDetails && (
          <>
            <br />
            <DocCartView
              readOnly
              cartConfirmed
              cartId={cartDetails.id}
              // Match the H4 + margin class every other section on this page uses.
              headingTag="h4"
              headingClassName="navigo-module-sub-heading-margin"
              cartItems={cartTestItems}
              selectedProvider={
                cartSelectedProvider || {
                  id: cartDetails.serviceProviderId,
                  name:
                    appointment?.serviceProviderName ||
                    `Provider #${cartDetails.serviceProviderId}`,
                  address: appointment?.serviceProviderAddress || "-",
                  isHomeSample: appointment?.mode === MODES.HOME_SAMPLE,
                  assignedServiceMode: appointment?.mode || "-",
                  totalPrice: 0,
                }
              }
              addressSelected={cartAddressSelected}
              documentsList={cartDocumentsList}
              selectedDocument={cartSelectedDocument}
              onSelectDocument={setCartSelectedDocument}
              docToken={token}
              planWalletIncluded={cartPlanWalletIncluded}
              // Backend-resolved on the cart GET, so this read-only view does not have to
              // re-derive the relation rule from the family list. Suppresses the per-item
              // tags only — this page has no "Booking for" section, which is the one place
              // the reason is spelled out.
              walletBlockedForMember={
                cartDetails?.walletBlockedForMember === true
              }
              priceRows={cartPriceRows}
              priceTotal={cartPriceTotal}
            />
          </>
        )}

        {/* ~6 Payment and refund details*/}
        {/* When the appointment carries a non-empty eventHistory, render the
            merged event-history table; otherwise fall back to the original
            PaymentAndRefund (untouched). */}
        {Array.isArray(appointment?.eventHistory) &&
        appointment.eventHistory.length > 0 ? (
          <EventHistoryPaymentDetails
            appointment={appointment}
            fetchAppointment={fetchAppointment}
            resetDashboardReload={props.resetDashboardReload}
            profileDetails={
              appointment?.bookedFor !== 0
                ? primaryPatientInfoOnPageLoad
                : patientInfoOnPageLoad
            }
            onRefresh={() => {
              fetchAppointmentDetailsOnly();
            }}
            loaderToCheckPaymentStatus={loaderToCheckPaymentStatus}
          />
        ) : (
          <PaymentAndRefund
            appointment={appointment}
            fetchAppointment={fetchAppointment}
            resetDashboardReload={props.resetDashboardReload}
            profileDetails={
              appointment?.bookedFor !== 0
                ? primaryPatientInfoOnPageLoad
                : patientInfoOnPageLoad
            }
            onRefresh={() => {
              fetchAppointmentDetailsOnly();
            }}
            loaderToCheckPaymentStatus={loaderToCheckPaymentStatus}
          />
        )}

        {/* ~7 */}
        {Boolean(appointment?.serviceTypeID != 4) && (
          <div
            style={{
              width: "100%",
              border: "2px solid #D9D9D9",
              borderRadius: "16px",
              padding: "34px",
            }}
          >
            <div
              style={{ fontWeight: 700, fontSize: "24px", color: "#000000" }}
            >
              {`Documents related to appointment`}
            </div>
            <div
              style={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#757575",
                marginTop: "4px",
              }}
            >
              {`Reports, prescriptions, or uploaded files`}
            </div>
            {(appDocMap.length != 0 || isUploadingDoc) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "12px",
                }}
              >
                {isUploadingDoc ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#16A34A",
                    }}
                  >
                    <CircularProgress size={16} style={{ color: "#16A34A" }} />
                    {"Uploading..."}
                  </span>
                ) : (
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#16A34A",
                    }}
                  >
                    {`✓ ${appDocMap.length} documents uploaded`}
                  </span>
                )}
                {appDocMap.length != 0 && (
                  <>
                    <span style={{ color: "#D9D9D9" }}>{"|"}</span>
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "#757575",
                      }}
                    >
                      {`Last updated ${documentsLastUpdatedText}`}
                    </span>
                  </>
                )}
              </div>
            )}
            {appDocMap.length != 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginTop: "24px",
                }}
              >
                {appDocMap.map((doc) => (
                  <div
                    key={doc.id}
                    style={{
                      border: "1px solid #D9D9D9",
                      borderRadius: "8px",
                      padding: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        minWidth: 0,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F6F6F6",
                          borderRadius: "6px",
                          padding: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontIcon style={{ color: "#494949" }}>
                          {isImageDocument(doc.url) ? "image" : "description"}
                        </FontIcon>
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "#26284D",
                            overflowWrap: "break-word",
                          }}
                        >
                          {doc.title}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "150px",
                            flexWrap: "wrap",
                            marginTop: "2px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#757575",
                            }}
                          >
                            {`Uploaded on ${moment(doc.updatedAt).format(
                              "D MMM YYYY hh:mm A",
                            )}`}
                          </div>
                          {/* uploadedBy is empty on documents uploaded before
                              the field existed, so it is skipped when blank. */}
                          {typeof doc.uploadedBy === "string" &&
                            doc.uploadedBy.trim() !== "" && (
                              <div
                                style={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "#757575",
                                }}
                              >
                                {doc.uploadedBy}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        flexShrink: 0,
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => viewDocument(doc.url, token)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#00B3BC";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#00C9D3";
                        }}
                        style={{
                          backgroundColor: "#00C9D3",
                          color: "#FFFFFF",
                          border: "none",
                          borderRadius: "4px",
                          padding: "16px",
                          cursor: "pointer",
                          fontWeight: 600,
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {"View document"}
                      </button>
                      <button
                        type="button"
                        title="Download document"
                        onClick={() =>
                          downloadDocument(doc.url, token, doc.title)
                        }
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#F6F6F6";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#FFFFFF";
                        }}
                        style={{
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #D9D9D9",
                          borderRadius: "4px",
                          padding: "12px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        <FontIcon style={{ color: "#494949" }}>
                          {"file_download"}
                        </FontIcon>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <button
              type="button"
              disabled={loading}
              onClick={() => {
                handleUploadReportClick();
              }}
              onMouseEnter={(e) => {
                if (loading) return;
                e.currentTarget.style.backgroundColor = "#EF7C01";
                e.currentTarget.style.color = "#FFFFFF";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFFFFF";
                e.currentTarget.style.color = "#EF7C01";
              }}
              style={{
                marginTop: "24px",
                border: "1px solid #EF7C01",
                color: "#EF7C01",
                backgroundColor: "#FFFFFF",
                padding: "16px",
                borderRadius: "4px",
                cursor: loading ? "not-allowed" : "pointer",
                fontWeight: 600,
                transition: "background-color 0.2s ease, color 0.2s ease",
              }}
            >
              {appDocMap.length === 0
                ? "+ Upload document"
                : "+ Upload another document"}
            </button>
            <input
              type="file"
              hidden
              accept={"application/pdf,image/png,image/jpeg,image/jpg"}
              ref={uploadFileRef}
              onChange={handleUploadFile}
            />
          </div>
        )}

        {/* ~8 Appointment history — hidden entirely when there are no audits */}
        {appointmentAudits.length > 0 && (
          <div
            ref={appointmentHistoryRef}
            style={{
              width: "100%",
              border: "2px solid #D9D9D9",
              borderRadius: "16px",
              padding: "32px",
              marginTop: "36px",
            }}
          >
            <div
              style={{ fontWeight: 700, fontSize: "24px", color: "#000000" }}
            >
              {`Appointment history`}
            </div>
            <div
              style={{
                marginTop: "20px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                  }}
                >
                  <colgroup>
                    <col style={{ width: "70px" }} />
                    <col style={{ width: "10vw" }} />
                    <col style={{ width: "10vw" }} />
                    <col style={{ width: "10vw" }} />
                    <col style={{ width: "10vw" }} />
                    <col />
                  </colgroup>
                  <thead>
                    <tr style={{ backgroundColor: "#F6F6F6" }}>
                      <th style={auditHeaderCellStyle} />
                      <th style={auditHeaderCellStyle}>{`Status`}</th>
                      <th style={auditHeaderCellStyle}>{`Updated on`}</th>
                      <th style={auditHeaderCellStyle}>{`Updated by`}</th>
                      <th style={auditHeaderCellStyle}>{`Updated from`}</th>
                      <th style={auditHeaderCellStyle}>{`Comment`}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appointmentAudits.map((audit, index) => (
                      <tr key={`appointment-audit-${index}`}>
                        <td style={historyBodyCellStyle}>
                          <div style={auditBubbleStyle}>{index + 1}</div>
                        </td>
                        <td
                          style={{ ...historyBodyCellStyle, fontWeight: 500 }}
                        >
                          {audit?.statusName}
                        </td>
                        <td style={historyBodyCellStyle}>{audit?.updatedOn}</td>
                        <td style={historyBodyCellStyle}>{audit?.updatedBy}</td>
                        <td style={historyBodyCellStyle}>
                          {audit?.updatedFrom}
                        </td>
                        <td style={historyBodyCellStyle}>{audit?.comment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ~9 Call history — only for appointments that carry call events */}
        {callEvents.length > 0 && (
          <div
            style={{
              width: "100%",
              border: "2px solid #D9D9D9",
              borderRadius: "16px",
              padding: "32px",
              marginTop: "36px",
            }}
          >
            {/* ── Heading + reload ── mirrors the Payment details card. Call
                events ride along on the appointment, so re-fetching it is what
                refreshes this table. */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{ fontWeight: 700, fontSize: "24px", color: "#000000" }}
              >
                {`Call history`}
              </div>
              <div style={{ marginLeft: "32px", display: "flex" }}>
                <RefreshButton
                  onRefresh={() => {
                    fetchAppointmentDetailsOnly();
                  }}
                  loading={loaderToCheckPaymentStatus}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "26px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#F6F6F6" }}>
                      <th style={callHeaderCellStyle}>{`Disposition`}</th>
                      <th style={callHeaderCellStyle}>{`Missed by`}</th>
                      <th style={callHeaderCellStyle}>{`Customer number`}</th>
                      <th style={callHeaderCellStyle}>{`Start time`}</th>
                      <th style={callHeaderCellStyle}>{`Handle time`}</th>
                      <th style={callHeaderCellStyle}>{`Initiated by`}</th>
                      <th
                        style={{
                          ...callHeaderCellStyle,
                          width: recordingColumnWidth,
                          minWidth: recordingColumnWidth,
                        }}
                      >{`Recording`}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {callEvents.map((event, index) => {
                      const color = dispositionColor(event?.disposition);
                      const recordingId = Number(event?.["recording-id"] ?? 0);
                      return (
                        <tr key={`call-event-${event?.callid ?? index}`}>
                          <td style={historyBodyCellStyle}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {color && (
                                <span
                                  style={{
                                    height: "8px",
                                    width: "8px",
                                    borderRadius: "50%",
                                    backgroundColor: color,
                                    flexShrink: 0,
                                  }}
                                />
                              )}
                              <span
                                style={{
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: color ?? "#000000",
                                }}
                              >
                                {event?.disposition}
                              </span>
                            </div>
                          </td>
                          <td style={historyBodyCellStyle}>
                            {event?.missedByName
                              ? event?.missedBy
                                ? `${event.missedByName} (${
                                    event.missedBy.charAt(0).toUpperCase() +
                                    event.missedBy.slice(1)
                                  })`
                                : event.missedByName
                              : event?.missedBy
                                ? event.missedBy.charAt(0).toUpperCase() +
                                  event.missedBy.slice(1)
                                : "-"}
                          </td>
                          <td style={historyBodyCellStyle}>
                            {event?.["customer-number"] || "-"}
                          </td>
                          <td style={historyBodyCellStyle}>
                            {event?.["start-time"]}
                          </td>
                          <td style={historyBodyCellStyle}>
                            {event?.["handle-time"]}
                          </td>
                          <td style={historyBodyCellStyle}>
                            {event?.initiatedBy || "-"}
                          </td>
                          <td
                            style={{
                              ...historyBodyCellStyle,
                              width: recordingColumnWidth,
                              minWidth: recordingColumnWidth,
                            }}
                          >
                            {recordingId ? (
                              recordingUrls[recordingId] ? (
                                <audio
                                  controls
                                  autoPlay
                                  src={recordingUrls[recordingId]}
                                  style={{ height: "32px", width: "100%" }}
                                />
                              ) : (
                                <button
                                  type="button"
                                  disabled={loadingRecordingId === recordingId}
                                  onClick={() => playRecording(recordingId)}
                                  style={{
                                    border: "none",
                                    background: "none",
                                    padding: 0,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    color: "#F97F0F",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    cursor:
                                      loadingRecordingId === recordingId
                                        ? "default"
                                        : "pointer",
                                    fontFamily: "inherit",
                                  }}
                                >
                                  <RiPlayCircleLine
                                    style={{ fontSize: "14px" }}
                                  />
                                  {loadingRecordingId === recordingId
                                    ? `Loading...`
                                    : `Play recording`}
                                </button>
                              )
                            ) : (
                              <span
                                style={{
                                  fontWeight: 400,
                                  fontSize: "12px",
                                  color: "#757575",
                                }}
                              >
                                {`No recording`}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
      {openRescheduleDialog && (
        <>
          <DialogContainer
            id="appointment-reschedule-dialog"
            visible={openRescheduleDialog}
            focusOnMount={false}
            onHide={() => resetValues(1)}
            width={"880px"}
            // react-md's autosize measures the content with a ResizeObserver and
            // sets a JS maxHeight. That measurement goes stale when the slots
            // load and the first bucket auto-expands, leaving the content
            // uncapped: it spills out of the 92vh dialog and can't be scrolled
            // until an accordion toggle triggers a re-measure. Capping the
            // content in CSS instead keeps it scrollable at every height.
            autosizeContent={false}
            dialogStyle={{
              borderRadius: "16px",
              maxWidth: "96vw",
              maxHeight: "92vh",
            }}
            contentStyle={{
              padding: "26px 24px",
              maxHeight: "92vh",
              overflowY: "auto",
              boxSizing: "border-box",
            }}
            style={{ maxHeight: "100vh", overflow: "auto" }}
          >
            <div className="rsd-dialog">
              <div className="rsd-header">
                <span className="rsd-heading">Reschedule appointment?</span>
                <button
                  type="button"
                  className="rsd-cross-btn"
                  onClick={() => {
                    resetValues(1);
                  }}
                >
                  <RiCloseLine style={{ fontSize: "20px" }} />
                </button>
              </div>
              <div className="rsd-divider" />

              {/* Appointment being rescheduled */}
              <div className="rsd-patient-box">
                <div className="rsd-patient-name">
                  {`${appointment?.patientName ?? ""} · PID ${patientIdValue ?? ""}`}
                </div>
                <div className="rsd-patient-sub">
                  {`Currently scheduled · ${appointmentDateTimeText}`}
                </div>
              </div>

              {/* Reason for rescheduling */}
              <div className="rsd-reason-question">
                {`Are you sure you want to reschedule this appointment? Please add a reason below.`}
                <span style={{ color: "#E44437" }}>{` *`}</span>
              </div>
              <div className="rsd-reason-list">
                {[...rescheduleReasons, OTHER_REASON].map((reason) => (
                  <button
                    key={reason}
                    type="button"
                    className={`rsd-reason-chip${
                      reasonSelected === reason ? " rsd-selected" : ""
                    }`}
                    onClick={() => {
                      setReasonSelected(reason);
                      if (reason !== OTHER_REASON) {
                        setOtherReasonComment("");
                      }
                    }}
                  >
                    {reason}
                  </button>
                ))}
              </div>
              {reasonSelected === OTHER_REASON && (
                <textarea
                  className="rsd-reason-comment"
                  placeholder="Add a comment..."
                  value={otherReasonComment}
                  onChange={(e) => setOtherReasonComment(e.target.value)}
                />
              )}

              {props?.data?.from === "SLOT_RESTRICTION_DASHBOARD" && (
                <>
                  <br />
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <TopNote
                        text="Appointments can be rescheduled directly from - Level 2(SP assigned on service) availability slots"
                        color="#DDF6EB"
                        borderColor="#1BC47D"
                      />
                    </Col>
                  </Row>
                </>
              )}
              <br />
              <div>
                {appointment?.serviceTypeID === SERVICE_TYPE.CONSULTATION &&
                  appointment?.mode != MODES.IN_PERSON_CONSULTATION && (
                    <>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Language`}
                            </div>
                            <div style={{ paddingTop: "10px" }}>
                              <Autocomplete
                                id="mp-navigo-service-mode-selection"
                                options={languages}
                                value={languageSelected}
                                multiple
                                onChange={(e, v) => {
                                  if (v) {
                                    setLanguageSelected(v);
                                  } else {
                                    setLanguageSelected(null);
                                  }
                                }}
                                getOptionLabel={(option) =>
                                  option ? option : ""
                                }
                                filterOptions={(options, { inputValue }) => {
                                  const searchText = inputValue.toLowerCase();

                                  return options.filter((option) => {
                                    const lang = option.toLowerCase() || "";

                                    return lang.includes(searchText);
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField2
                                    {...params}
                                    placeholder="Select"
                                    InputProps={{
                                      ...params.InputProps,
                                      style: {
                                        fontFamily: "Montserrat, sans-serif",
                                        marginTop: "8px",
                                      },
                                      classes: {
                                        underline: "custom-underline",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                {(appointment?.serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP ||
                  appointment?.serviceTypeID === SERVICE_TYPE.VACCINE) &&
                  ((appointment?.mode === MODES.CENTRE_VISIT &&
                    appointment?.serviceProviderGroupVendorName !=
                      APOLLO_VENDOR_CODE) ||
                    appointment?.mode === MODES.CAMP_SITE_VISIT) && (
                    <>
                      <Row>
                        <Col xs={12} sm={5} md={5} lg={5}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              {`Select location mode`}
                              <label className="navigo-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <Autocomplete
                                id="mp-navigo-location-mode-selection"
                                options={SELECT_LOCATION_MODE_OPTIONS}
                                getOptionLabel={(option) => option.label}
                                value={locationModeSelected}
                                disabled={loading}
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value?.value
                                }
                                onChange={(e, v) => {
                                  resetValues(10);
                                  if (v) {
                                    setLocationModeSelected(v);
                                  } else {
                                    setLocationModeSelected(null);
                                    getServiceProvider({
                                      type: 1,
                                      lang: [],
                                      state: null,
                                      city: null,
                                      locality: null,
                                    });
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField2
                                    {...params}
                                    placeholder="Select"
                                    InputProps={{
                                      ...params.InputProps,
                                      style: {
                                        fontFamily: "Montserrat, sans-serif",
                                        marginTop: "8px",
                                      },
                                      classes: {
                                        underline: "custom-underline",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        {locationModeSelected?.value ==
                          LOCATION_MODE.GOOGLE_MAPS && (
                          <>
                            <Col xs={12} sm={1} md={1} lg={1}>
                              <div style={{ height: "20px" }}></div>
                            </Col>
                            <Col xs={12} sm={3} md={3} lg={3}>
                              <div
                                style={{ marginTop: "14px", width: "175px" }}
                              >
                                <Button
                                  className={
                                    !geoLocData?.latLng
                                      ? "zy-btn-blue-1"
                                      : "zy-btn-orange-1"
                                  }
                                  onClick={() => {
                                    handleOpenLocationPicker();
                                  }}
                                >
                                  {!geoLocData?.latLng
                                    ? "Choose location"
                                    : "Change location"}
                                </Button>
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>

                      {locationModeSelected?.value ==
                        LOCATION_MODE.GOOGLE_MAPS &&
                        geoLocData?.latLng !== null && (
                          <>
                            <br />
                            <Row>
                              <Col xs={12} sm={11} md={11} lg={11}>
                                <div className="navigo-module-create-service-field-container">
                                  <div className="navigo-module-label">
                                    {`Location`}
                                  </div>
                                  <div>
                                    <TextField
                                      value={
                                        formatAddress(geoLocData?.address) ?? ""
                                      }
                                      lineDirection="left"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}

                      {locationModeSelected?.value == LOCATION_MODE.MANUAL && (
                        <>
                          <br />
                          <Row>
                            <Col xs={12} sm={3} md={3} lg={3}>
                              <div className="navigo-module-create-service-field-container">
                                <div className="navigo-module-label">
                                  {`Select state`}
                                  {stateSelected != null && (
                                    <label className="navigo-module-label-red">
                                      *
                                    </label>
                                  )}
                                </div>
                                <div>
                                  <Autocomplete
                                    id="mp-navigo-state-selection"
                                    options={stateList}
                                    disabled={loading}
                                    value={stateSelected}
                                    onChange={(e, v) => {
                                      if (v) {
                                        if (stateSelected != null) {
                                          setCityList([]);
                                          setCitySelected(null);
                                          setLocalityList([]);
                                          setLocalitySelected(null);
                                        }
                                        resetValues(2);
                                        setStateSelected(v);
                                      } else {
                                        setStateSelected(null);

                                        resetValues(2);
                                        setCityList([]);
                                        setCitySelected(null);
                                        setLocalityList([]);
                                        setLocalitySelected(null);
                                      }
                                    }}
                                    getOptionLabel={(option) =>
                                      option ? option : ""
                                    }
                                    filterOptions={(
                                      options,
                                      { inputValue },
                                    ) => {
                                      const searchText =
                                        inputValue.toLowerCase();

                                      return options.filter((option) => {
                                        const state =
                                          option.toLowerCase() || "";

                                        return state.includes(searchText);
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField2
                                        {...params}
                                        placeholder="Select"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: {
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            marginTop: "8px",
                                          },
                                          classes: {
                                            underline: "custom-underline",
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col xs={12} sm={1} md={1} lg={1}>
                              <div style={{ height: "20px" }}></div>
                            </Col>
                            <Col xs={12} sm={3} md={3} lg={3}>
                              <div className="navigo-module-create-service-field-container">
                                <div className="navigo-module-label">
                                  {`Select city`}
                                  {stateSelected != null && (
                                    <label className="navigo-module-label-red">
                                      *
                                    </label>
                                  )}
                                </div>
                                <div>
                                  <Autocomplete
                                    id="mp-navigo-city-selection"
                                    options={cityList}
                                    disabled={loading || stateSelected === null}
                                    value={citySelected}
                                    onChange={(e, v) => {
                                      if (v) {
                                        if (citySelected != null) {
                                          setLocalityList([]);
                                          setLocalitySelected(null);
                                        }
                                        resetValues(2);
                                        setCitySelected(v);
                                      } else {
                                        setCitySelected(null);

                                        resetValues(2);
                                        setLocalityList([]);
                                        setLocalitySelected(null);
                                      }
                                    }}
                                    getOptionLabel={(option) =>
                                      option ? option : ""
                                    }
                                    filterOptions={(
                                      options,
                                      { inputValue },
                                    ) => {
                                      const searchText =
                                        inputValue.toLowerCase();

                                      return options.filter((option) => {
                                        const city = option.toLowerCase() || "";

                                        return city.includes(searchText);
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField2
                                        {...params}
                                        placeholder="Select"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: {
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            marginTop: "8px",
                                          },
                                          classes: {
                                            underline: "custom-underline",
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col xs={12} sm={1} md={1} lg={1}>
                              <div style={{ height: "20px" }}></div>
                            </Col>
                            <Col xs={12} sm={3} md={3} lg={3}>
                              <div className="navigo-module-create-service-field-container">
                                <div className="navigo-module-label">{`Select locality`}</div>
                                <div>
                                  <Autocomplete
                                    id="mp-navigo-locality-selection"
                                    options={localityList}
                                    disabled={loading || citySelected === null}
                                    value={localitySelected}
                                    onChange={(e, v) => {
                                      if (v) {
                                        resetValues(2);
                                        getServiceProvider({
                                          type: 3,
                                          lang: [],
                                          state: stateSelected,
                                          city: citySelected,
                                          locality: v,
                                        });
                                        setLocalitySelected(v);
                                      } else {
                                        setLocalitySelected(null);

                                        resetValues(2);
                                        getServiceProvider({
                                          type: 3,
                                          lang: [],
                                          state: stateSelected,
                                          city: citySelected,
                                          locality: null,
                                        });
                                      }
                                    }}
                                    getOptionLabel={(option) =>
                                      option ? option : ""
                                    }
                                    filterOptions={(
                                      options,
                                      { inputValue },
                                    ) => {
                                      const searchText =
                                        inputValue.toLowerCase();

                                      return options.filter((option) => {
                                        const locality =
                                          option.toLowerCase() || "";

                                        return locality.includes(searchText);
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField2
                                        {...params}
                                        placeholder="Select"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: {
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            marginTop: "8px",
                                          },
                                          classes: {
                                            underline: "custom-underline",
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}

                      {locationModeSelected?.value ==
                        LOCATION_MODE.SAVED_ADDRESSES && (
                        <>
                          <br />
                          <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                              <div className="navigo-module-create-service-field-container">
                                <div className="navigo-module-label">
                                  {`Select address`}
                                  <label className="navigo-module-label-red">
                                    {" "}
                                    *
                                  </label>
                                </div>
                                <div>
                                  <Autocomplete
                                    id="mp-navigo-address-selection"
                                    options={addressList}
                                    value={addressSelected}
                                    disabled={loading}
                                    onOpen={() => {
                                      getPatientAddress();
                                    }}
                                    onChange={(e, v) => {
                                      resetValues(11);
                                      if (v) {
                                        setLoading(true);
                                        getLocationFromSavedAddress(v);
                                      } else {
                                        setAddressSelected(null);
                                      }
                                    }}
                                    getOptionLabel={(option) =>
                                      option
                                        ? `${option.line1}, ${option.line2}, ${
                                            option.landmark &&
                                            option.landmark != ""
                                              ? `${option.landmark}, `
                                              : ""
                                          }${option.city}, ${option.district}, ${
                                            option.state
                                          } - ${option.pincode}`
                                        : ""
                                    }
                                    filterOptions={(
                                      options,
                                      { inputValue },
                                    ) => {
                                      const searchText =
                                        inputValue.toLowerCase();

                                      return options.filter((option) => {
                                        const addressString = [
                                          option.line1,
                                          option.line2,
                                          option.landmark,
                                          option.city,
                                          option.district,
                                          option.state,
                                          option.pincode,
                                        ]
                                          .filter(Boolean)
                                          .join(", ")
                                          .toLowerCase();

                                        return addressString.includes(
                                          searchText,
                                        );
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField2
                                        {...params}
                                        placeholder="Select"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: {
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            marginTop: "8px",
                                          },
                                          classes: {
                                            underline: "custom-underline",
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}

                      <br />

                      <Row>
                        {(locationModeSelected?.value ==
                          LOCATION_MODE.GOOGLE_MAPS ||
                          locationModeSelected?.value ==
                            LOCATION_MODE.SAVED_ADDRESSES) &&
                          geoLocData?.latLng !== null && (
                            <>
                              <Col xs={12} sm={3} md={3} lg={3}>
                                <div className="navigo-module-create-service-field-container">
                                  <div className="navigo-module-label">
                                    {`Area radius`}
                                    <label className="navigo-module-label-red">
                                      {" "}
                                      *
                                    </label>
                                  </div>
                                  <div>
                                    <Autocomplete
                                      id="mp-navigo-service-range1-selection"
                                      options={LOCATION_RANGE_KMS_OPTIONS}
                                      value={rangeOptionSelected}
                                      disabled={
                                        loading ||
                                        geoLocData?.latLng == null ||
                                        (addressSelected == null &&
                                          locationModeSelected?.value ==
                                            LOCATION_MODE.SAVED_ADDRESSES)
                                      }
                                      getOptionLabel={(option) =>
                                        option?.label ?? ""
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option?.value === value?.value
                                      }
                                      onChange={(e, v) => {
                                        resetValues(2);
                                        handleRadiusKmSelected(
                                          v,
                                          false,
                                          geoLocData?.latLng,
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField2
                                          {...params}
                                          placeholder="Select"
                                          InputProps={{
                                            ...params.InputProps,
                                            style: {
                                              fontFamily:
                                                "Montserrat, sans-serif",
                                              marginTop: "8px",
                                            },
                                            classes: {
                                              underline: "custom-underline",
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} sm={1} md={1} lg={1}>
                                <div style={{ height: "20px" }}></div>
                              </Col>
                            </>
                          )}{" "}
                      </Row>
                    </>
                  )}
                {(appointment?.serviceTypeID === SERVICE_TYPE.CONSULTATION &&
                  appointment?.mode === MODES.IN_PERSON_CONSULTATION) ||
                ((appointment?.serviceTypeID === SERVICE_TYPE.HEALTH_CHECKUP ||
                  appointment?.serviceTypeID === SERVICE_TYPE.VACCINE) &&
                  (appointment?.mode === MODES.HOME_SAMPLE ||
                    (appointment?.mode === MODES.CENTRE_VISIT &&
                      appointment?.serviceProviderGroupVendorName ===
                        APOLLO_VENDOR_CODE))) ? (
                  <></>
                ) : (
                  <>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div>
                            <Checkbox
                              id="mp-appointment-checkbox-3"
                              name="mp-appointment-checkbox-3"
                              style={{ marginLeft: -13, marginTop: 3 }}
                              disabled={
                                !isAutoSPAllowed(appointment?.mode) ||
                                appointment?.mode === MODES.HOME_SAMPLE ||
                                loading
                              }
                              checked={selectServiceProviderCheckbox}
                              onChange={(value, proxy) => {
                                setDateSelected(null);
                                setSlotSelected(null);
                                setSlotWindow(EMPTY_SLOT_WINDOW);
                                setServiceProviderSelected(null);
                                setServiceProviderAutoSelected(null);
                                if (selectServiceProviderCheckbox) {
                                  setSelectServiceProviderCheckbox(false);
                                } else {
                                  setSelectServiceProviderCheckbox(true);
                                }
                              }}
                            />
                          </div>
                          <div className="navigo-module-label-checkbox">
                            {`Select service provider or check mark to select automatically`}{" "}
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                        </div>

                        <div
                          className="navigo-module-checkbox-field-container"
                          style={{ marginTop: "-16px" }}
                        >
                          <div>
                            <Autocomplete
                              id="mp-navigo-service-provider-selection"
                              options={serviceProviderListToShow}
                              value={serviceProviderSelected}
                              disabled={
                                selectServiceProviderCheckbox ||
                                appointment?.mode === MODES.HOME_SAMPLE ||
                                ((appointment?.mode === MODES.CAMP_SITE_VISIT ||
                                  appointment?.mode === MODES.CENTRE_VISIT) &&
                                  ((locationModeSelected?.value ==
                                    LOCATION_MODE.MANUAL &&
                                    stateSelected != null &&
                                    citySelected === null) ||
                                    ((locationModeSelected?.value ==
                                      LOCATION_MODE.GOOGLE_MAPS ||
                                      locationModeSelected?.value ==
                                        LOCATION_MODE.SAVED_ADDRESSES) &&
                                      !rangeOptionSelected))) ||
                                loading
                              }
                              onChange={(e, v) => {
                                if (v) {
                                  if (serviceProviderSelected != null) {
                                    resetValues(7);
                                  }
                                  setServiceProviderSelected(v);
                                } else {
                                  setServiceProviderSelected(null);

                                  resetValues(7);
                                }
                              }}
                              getOptionLabel={(option) =>
                                option
                                  ? `(${option.id}) ${option.name}${
                                      appointment?.serviceTypeID ===
                                      SERVICE_TYPE.HEALTH_CHECKUP
                                        ? ` -${option?.address?.city}-${option?.address?.landmark}`
                                        : ""
                                    }${
                                      (locationModeSelected?.value ===
                                        LOCATION_MODE.GOOGLE_MAPS ||
                                        locationModeSelected?.value ===
                                          LOCATION_MODE.SAVED_ADDRESSES) &&
                                      option?.distanceFromSource >= 0
                                        ? ` [${formatDistanceKm(option.distanceFromSource)}]`
                                        : ""
                                    }`
                                  : ""
                              }
                              filterOptions={(options, { inputValue }) => {
                                const searchText = inputValue.toLowerCase();

                                return options.filter((option) => {
                                  const label = `(${option.id}) ${option.name}${
                                    appointment?.serviceTypeID ===
                                    SERVICE_TYPE.HEALTH_CHECKUP
                                      ? ` -${option?.address?.city}-${option?.address?.landmark}`
                                      : ""
                                  }`.toLowerCase();

                                  return label.includes(searchText);
                                });
                              }}
                              renderOption={(option, state) => (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {option?.margin?.colour ? (
                                    <span
                                      style={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: "50%",
                                        backgroundColor: option.margin.colour,
                                        marginRight: 8,
                                      }}
                                    />
                                  ) : null}
                                  {`(${option.id}) ${option.name}${
                                    appointment?.serviceTypeID ===
                                    SERVICE_TYPE.HEALTH_CHECKUP
                                      ? ` -${option?.address?.city}-${option?.address?.landmark}`
                                      : ""
                                  }${
                                    (locationModeSelected?.value ===
                                      LOCATION_MODE.GOOGLE_MAPS ||
                                      locationModeSelected?.value ===
                                        LOCATION_MODE.SAVED_ADDRESSES) &&
                                    option?.distanceFromSource >= 0
                                      ? ` [${formatDistanceKm(option.distanceFromSource)}]`
                                      : ""
                                  }`}
                                </div>
                              )}
                              renderInput={(params) => (
                                <TextField2
                                  {...params}
                                  placeholder="Select"
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: serviceProviderSelected
                                      ?.margin?.colour ? (
                                      <span
                                        style={{
                                          width: 12,
                                          height: 12,
                                          borderRadius: "50%",
                                          backgroundColor:
                                            serviceProviderSelected.margin
                                              .colour,
                                          marginRight: 8,
                                          marginLeft: 4,
                                        }}
                                      />
                                    ) : null,
                                    style: {
                                      fontFamily: "Montserrat, sans-serif",
                                      marginTop: "8px",
                                    },
                                    classes: {
                                      underline: "custom-underline",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}

                {/* New date: a 7-day strip from /available-slots/range, then the
                    selected day's slots grouped into time-of-day accordions. */}
                <div className="rsd-slots-section">
                  <div className="rsd-col-heading">
                    {`New date`}
                    {/* The tiles stay on screen while a window loads, so the
                        progress is shown here instead of in their place. */}
                    {slotWindow.loading && (
                      <CircularProgress
                        size={12}
                        thickness={5}
                        style={{ color: "#10B981" }}
                      />
                    )}
                  </div>
                  <div className="rsd-date-strip">
                    {slotStripDays.map((day) => {
                      const available = isDayAvailable(day);
                      const isSelected =
                        available && selectedDateKey === day.dayDate;
                      return (
                        <button
                          key={day.dayDate}
                          type="button"
                          className={`rsd-date-tile${
                            available ? " rsd-date-tile-available" : ""
                          }${isSelected ? " rsd-selected" : ""}`}
                          // A grey day has nothing to book, so it can't be picked.
                          disabled={!available}
                          onClick={() =>
                            setDateSelected(moment(day.dayDate, "YYYY-MM-DD"))
                          }
                        >
                          <div className="rsd-date-tile-day">{day.dayStr}</div>
                          <div className="rsd-date-tile-num">{day.dayNum}</div>
                        </button>
                      );
                    })}
                    <button
                      type="button"
                      className="rsd-date-tile rsd-calendar-tile"
                      title="Choose another date"
                      disabled={loading || !isProviderChosen}
                      onClick={() => setCustomDatePickerOpen(true)}
                    >
                      <RiCalendar2Line style={{ fontSize: "18px" }} />
                    </button>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <DatePicker
                        value={dateSelected}
                        autoOk={true}
                        open={customDatePickerOpen}
                        onOpen={() => setCustomDatePickerOpen(true)}
                        onClose={() => setCustomDatePickerOpen(false)}
                        onChange={(date) => {
                          // The picked date opens the next window and is the one
                          // selected in it.
                          setSlotRangeStartDate(
                            moment(date).format("YYYY-MM-DD"),
                          );
                          setDateSelected(moment(date));
                          setCustomDatePickerOpen(false);
                        }}
                        minDate={calendarMinDate}
                        maxDate={calendarMaxDate}
                        TextFieldComponent={() => null}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="rsd-date-hint">
                    {`Grey dates have no free slots · calendar opens any future date`}
                  </div>

                  <div className="rsd-slots-heading">
                    {dateSelected == null
                      ? `Available slots`
                      : `Available slots · ${moment(dateSelected).format(
                          "ddd, D MMM",
                        )}`}
                  </div>
                  {dateSelected == null ? (
                    <div className="rsd-placeholder-text">
                      {`Select a date to see the available slots`}
                    </div>
                  ) : slotWindow.loading ? (
                    <div className="rsd-slots-loader">
                      <CircularProgress
                        size={22}
                        thickness={4}
                        style={{ color: "#10B981" }}
                      />
                    </div>
                  ) : slotWindow.error != null ? (
                    <div className="rsd-placeholder-text">
                      {`Could not load slots`}
                    </div>
                  ) : selectedDaySlotBuckets.length === 0 ? (
                    <div className="rsd-placeholder-text">
                      {`No slots available on this date`}
                    </div>
                  ) : (
                    <div className="rsd-slot-buckets">
                      {selectedDaySlotBuckets.map(({ bucket, slots }) => {
                        const BucketIcon = SLOT_BUCKET_ICONS[bucket];
                        const isExpanded = expandedSlotBuckets.includes(bucket);
                        return (
                          <div key={bucket} className="rsd-slot-bucket">
                            <button
                              type="button"
                              className="rsd-slot-bucket-header"
                              aria-expanded={isExpanded}
                              onClick={() => toggleSlotBucket(bucket)}
                            >
                              <BucketIcon className="rsd-slot-bucket-icon" />
                              <span className="rsd-slot-bucket-title">
                                {bucket}
                              </span>
                              <MdOutlineKeyboardArrowDown
                                className={`rsd-slot-bucket-chevron${
                                  isExpanded ? " rsd-expanded" : ""
                                }`}
                              />
                            </button>
                            <div className="rsd-slot-bucket-divider" />
                            {isExpanded && (
                              <div className="rsd-slot-grid">
                                {slots.map((slot) => (
                                  <button
                                    key={slot.key}
                                    type="button"
                                    className={`rsd-slot-btn${
                                      slotSelected?.key === slot.key
                                        ? " rsd-selected"
                                        : ""
                                    }`}
                                    onClick={() => setSlotSelected(slot)}
                                  >
                                    <div className="rsd-slot-label">
                                      {slotLabel(slot)}
                                    </div>
                                    {/* Only one backend slot path computes a
                                        count; every other one leaves it at 0,
                                        so 0 means "not tracked" rather than
                                        "full" and the slot stays bookable. */}
                                    {slot.availableCount > 0 && (
                                      <div className="rsd-slot-count">
                                        {`${slot.availableCount} ${
                                          slot.availableCount === 1
                                            ? "slot"
                                            : "slots"
                                        }`}
                                      </div>
                                    )}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                <div className="rsd-footer">
                  <button
                    type="button"
                    className="rsd-btn-secondary"
                    onClick={() => {
                      resetValues(1);
                    }}
                  >
                    {"No, go back"}
                  </button>
                  <button
                    id="reschedule_button"
                    type="button"
                    className="rsd-btn-primary"
                    disabled={loading}
                    onClick={() => {
                      rescheduleAppointment();
                    }}
                  >
                    {"Yes, reschedule"}
                  </button>
                </div>
              </div>
            </div>
          </DialogContainer>
        </>
      )}
      {/* Profile details — the only place the real age/gender are shown. Closes
          on the X, the Close button, or a click outside (DialogContainer's
          default non-modal behaviour). */}
      {profileDialogOpen && (
        <DialogContainer
          id="appointment-profile-details-dialog"
          visible={profileDialogOpen}
          focusOnMount={false}
          onHide={() => setProfileDialogOpen(false)}
          width={"420px"}
          autosizeContent={true}
          dialogStyle={{ borderRadius: "16px" }}
          contentStyle={{ padding: "22px 20px" }}
        >
          <div style={{ fontFamily: "Montserrat, sans-serif" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <div
                style={{
                  color: "#1B1E28",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                {`Profile details`}
              </div>
              <button
                type="button"
                title="Close"
                onClick={() => setProfileDialogOpen(false)}
                style={{
                  flexShrink: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "32px",
                  width: "32px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#F5F7FA",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <RiCloseLine size={18} color="#666B7A" />
              </button>
            </div>
            {/* Bleeds past the dialog's 20px side padding so it runs edge to edge. */}
            <div
              style={{
                marginTop: "26px",
                marginLeft: "-20px",
                marginRight: "-20px",
                height: "1px",
                backgroundColor: "#EBEDF5",
              }}
            />
            <div style={{ marginTop: "24px", display: "flex" }}>
              <div style={{ width: "50%" }}>
                <div style={profileLabelStyle}>{`Age`}</div>
                <div style={profileValueStyle}>{appointment?.patientAge}</div>
              </div>
              <div style={{ width: "50%" }}>
                <div style={profileLabelStyle}>{`Gender`}</div>
                <div style={profileValueStyle}>{profileGenderValue}</div>
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <div style={profileLabelStyle}>{`Date of birth`}</div>
              <div style={profileValueStyle}>
                {appointment?.patientDob ?? ""}
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <div style={profileLabelStyle}>{`Email`}</div>
              <div style={profileValueStyle}>
                {appointment?.patientEmail ?? ""}
              </div>
            </div>
            <div
              style={{
                marginTop: "32px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                type="button"
                onClick={() => setProfileDialogOpen(false)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#D96B08";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F97F0F";
                }}
                style={{
                  borderRadius: "10px",
                  padding: "10px 22px",
                  color: "#FFFFFF",
                  fontWeight: 600,
                  fontSize: "13px",
                  backgroundColor: "#F97F0F",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  transition: "background-color 0.2s ease",
                }}
              >
                {"Close"}
              </button>
            </div>
          </div>
        </DialogContainer>
      )}
      {rescheduledSummary != null && (
        <DialogContainer
          id="appointment-reschedule-success-dialog"
          visible={rescheduledSummary != null}
          focusOnMount={false}
          onHide={() => setRescheduledSummary(null)}
          width={"360px"}
          autosizeContent={true}
          dialogStyle={{ borderRadius: "16px" }}
          contentStyle={{ padding: "26px 24px" }}
        >
          <div className="rsd-success">
            <img src={successGif} alt="success" className="rsd-success-img" />
            <div className="rsd-success-heading">
              {`Appointment rescheduled successfully`}
            </div>
            <div className="rsd-success-sub">{rescheduledSummary}</div>
            <button
              type="button"
              className="rsd-success-btn"
              onClick={() => setRescheduledSummary(null)}
            >
              {"Done"}
            </button>
          </div>
        </DialogContainer>
      )}
      {openCartReschedule && (
        <CartRescheduleDialog
          appointment={appointment}
          open={openCartReschedule}
          onClose={() => setOpenCartReschedule(false)}
          onBusyChange={setLoading}
          onRescheduled={() => {
            onRefreshStatus();
          }}
        />
      )}
      {updatePatientInfoDialog && (
        <DialogContainer
          id="appointment-update-patient-info-dialog"
          visible={updatePatientInfoDialog}
          focusOnMount={false}
          onHide={() => {
            !loadingProfileUpdate && closePatientInfoDialog();
          }}
          width={"600px"}
          autosizeContent={true}
          style={{ maxHeight: "100vh", overflow: "auto" }}
        >
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ marginTop: "5px" }}>
                <h3>Update missing profile details</h3>
              </div>
              <div>
                <Button
                  raised
                  disabled={loadingProfileUpdate}
                  className={
                    loadingProfileUpdate
                      ? "navigo-module-button-save-disabled"
                      : "navigo-module-button-save-enabled"
                  }
                  onClick={() => {
                    updatePatientInfo(patientInfo);
                  }}
                >
                  {"Save"}
                </Button>
              </div>
            </div>
            <br />
            {patientInfo && (
              <>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">{`User name`}</div>
                      <div>
                        <TextField
                          value={
                            patientInfo
                              ? `${patientInfo.firstName} ${patientInfo.lastName}`
                              : ""
                          }
                          lineDirection="left"
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <br />
                {isDOBEmpty(patientInfo) && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Date of birth`}
                            <label className="navigo-module-label-red">*</label>
                          </div>
                          <div style={{ paddingTop: "10px" }}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                              <KeyboardDatePicker
                                style={{ width: "100%" }}
                                value={newDob}
                                onChange={(date) => {
                                  setNewDob(date);
                                }}
                                autoOk={true}
                                className="navigo-module-appointment-datepicker"
                                format="DD MMM YYYY"
                                placeholder="DD MMM YYYY"
                                keyboardIcon={
                                  <FontIcon>calendar_month</FontIcon>
                                }
                                variant="inline"
                                minDate={moment().subtract(100, "years")}
                                maxDate={moment()}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}
                {isEmailEmpty(patientInfo) && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            {`Email Id`}
                          </div>
                          <div>
                            <TextField
                              value={newEmail}
                              lineDirection="left"
                              onChange={(e) => {
                                if (e.length <= 50) {
                                  setNewEmail(e.trim());
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}
              </>
            )}
          </div>
        </DialogContainer>
      )}
      {updateExtOrderIdDialog && (
        <DialogContainer
          id="appointment-update-external-order-id-dialog"
          visible={updateExtOrderIdDialog}
          focusOnMount={false}
          onHide={() => {}}
          width={"700px"}
          autosizeContent={true}
          dialogStyle={{ borderRadius: "10px" }}
          style={{ maxHeight: "100vh", overflow: "auto" }}
        >
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ marginTop: "5px" }}>
                <h3>Update External order ID</h3>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <Button
                    raised
                    disabled={loading}
                    className={
                      loading
                        ? "navigo-module-button-save-disabled"
                        : "navigo-module-button-save-enabled"
                    }
                    onClick={() => {
                      if (!loading) {
                        updateExtOrderId();
                      }
                    }}
                  >
                    {"Save"}
                  </Button>
                </div>
                <div>
                  <Button
                    raised
                    disabled={loading}
                    className={"navigo-module-button-cancel"}
                    onClick={() => {
                      if (!loading) {
                        setNewExtOrderId("");
                        setUpdateExtOrderIdDialog(false);
                      }
                    }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
              </div>
            </div>
            <br />
            <div>
              <Row>
                <Col xs={12} sm={7} md={7} lg={7}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label">{`New External order ID`}</div>
                    <div>
                      <TextField
                        value={newExtOrderId}
                        lineDirection="left"
                        onChange={(e) => {
                          const sanitized = e.replace(/[^a-zA-Z0-9\-_.]/g, "");
                          if (sanitized.length <= 100) {
                            setNewExtOrderId(sanitized);
                          }
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <br />
          </div>
        </DialogContainer>
      )}
      {
        <LocationSearchDialog
          dialogState={dialogState}
          setDialogState={setDialogState}
          closeDialog={closeDialog}
        />
      }
      {showCancelAppDialog && appToBeCancelled && (
        <CancelAppointmentDialog
          state={
            appToBeCancelled.refundStatus === REFUND_STATUS.ELIGIBLE_APPLICABLE
              ? CANCEL_APP_OPTION.CANCEL_WITH_REFUND
              : appToBeCancelled.refundStatus ===
                  REFUND_STATUS.ELIGIBLE_NOT_APPLICABLE
                ? CANCEL_APP_OPTION.CANCEL_WITHOUT_REFUND
                : CANCEL_APP_OPTION.JUST_CANCEL
          }
          show={showCancelAppDialog}
          setCancelAppOption={setCancelAppOption}
          setShowCancelAppDialog={setShowCancelAppDialog}
          appToBeCancelled={appToBeCancelled}
        />
      )}
      {
        <RefundDialog
          dialogState={refundDialogState}
          setDialogState={setRefundDialogState}
          handleClose={handleRefundDialogClose}
        />
      }
      {appToBeCancelledNewFlow && (
        <CancelAppointmentFlow
          appointment={appToBeCancelledNewFlow}
          statusToBeApplied={statusToBeApplied}
          onClose={() => {
            setAppToBeCancelledNewFlow(null);
            setStatusToBeApplied(null);
          }}
          /* After the money decision, not over it: the flow closes itself and
             the note follows, exactly as an ordinary status change does — for a
             CONSULTATION only. `isConsultation` rather than `opensCallNote`
             because the status is not in scope here as reliably as the
             appointment is (`statusToBeApplied` is cleared by onClose, whose
             order against onCompleted is the flow's business), and every status
             that reaches this flow is a cancel-family one — never one of the
             two the other rule excludes. */
          onCompleted={() => {
            onRefreshStatus();
            if (isConsultation(appToBeCancelledNewFlow)) {
              setCallNoteFor(appToBeCancelledNewFlow);
            }
          }}
        />
      )}

      {/* Keyed on the person the appointment is FOR — legacy's own
          `bookedFor == 0 ? patientID : bookedFor` (NavigoDashboard.js:
          2074-2078), the same rule the v2 board's "Add callnote" uses — and on
          THIS appointment, which is what the note's templates read. */}
      {callNoteFor ? (
        <CallNoteModal
          patient={{
            id: callNoteFor.bookedFor || callNoteFor.patientID,
            firstName: callNoteFor.patientName || "",
            lastName: "",
          }}
          appointment={callNoteFor}
          onClose={() => setCallNoteFor(null)}
        />
      ) : null}
    </div>
  );
};

export default DocumentUpload;
